import React, {
  ReactElement,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import { Entity } from '../../types/entities/Entity';
import { Schema } from '../../types/Schema';
import { CSVReader } from '../CSVReader';
import CsvDownloader from 'react-csv-downloader';
import { toPng } from 'html-to-image';
import api from '../../services/api';
import { convert } from 'html-to-text';
import ExcelJS from 'exceljs';
import Popover from '@mui/material/Popover';
import {
  Autocomplete,
  IconButton,
  Button,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  TextField,
  Typography,
  CircularProgressProps,
  Dialog,
  InputBase, Divider,
} from '@mui/material';
import CloudDownloadRoundedIcon from '@mui/icons-material/CloudDownloadRounded';
import RemoveRedEyeRoundedIcon from '@mui/icons-material/RemoveRedEyeRounded';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import RemoveRoundedIcon from '@mui/icons-material/RemoveRounded';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {
  CloudUploadRounded,
  DeleteSweepRounded,
  DifferenceRounded,
  DownloadRounded,
  ExpandLessRounded,
  ExpandMoreRounded,
  FilterAltRounded, RotateRightRounded,
  SaveAltRounded,
  SearchRounded,
  TuneRounded,
  ViewWeekRounded,
} from '@mui/icons-material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import moment from 'moment';
import { debounce } from 'lodash';
import { PeriodSelector } from '../PeriodSelector/PeriodSelector';
import { useStateContext } from '../../hooks/useStateContext';
import { useLocation } from 'react-router-dom';
import { DispatchContext } from '../../contexts/DispatchContext';
import Box from '@mui/material/Box';
import { SPSelectField } from './fields/SPSelectField';
import { group } from '../../schema/group';
import { enumItems } from '../../schema/enumItems';
import { statuses } from '../../schema/statuses';
import { SPSelectUserField } from './fields/SPSelectUserField';
import { userByRole } from '../../schema/userByRole';
import Tooltip from '@mui/material/Tooltip';
import LargePopper from './assets/LargePopper';
import CircularProgress from '@mui/material/CircularProgress';
import { processColumns } from './Header/utils/processColumns';
import { ServiceReservationModificationDialog } from './layout/ServiceReservationModificationDialog';
import useMediaQuery from '@mui/material/useMediaQuery';
import { alpha, styled, useTheme } from '@mui/material/styles';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import { GuideSchedule } from '../Custom/Action/GuideSchedule';
import { gridFilteredSortedRowEntriesSelector } from '@mui/x-data-grid-pro';
import TablePagination from '@mui/material/TablePagination';
import AddIcon from '@mui/icons-material/Add';
import toast from "react-hot-toast";

type Props<T extends Entity> = {
  schema: Schema<T>;
  onEntityAdded: () => void;
  newEntityFixedValues?: any;
  showCSVImport: boolean;
  fillOptions: boolean;
  rows: any;
  fillOptionSend: (type: string) => void;
  setCurrentEditedRow?: (value: any) => void;
  setCurrentAddNewRow?: (value: any) => void;
  onServiceProviderChange?: (value: any) => void;
  onGuideFastSearchChange?: (value: any) => void;
  onSalesPartnerSearchChange?: (value: any) => void;
  onSearchChange?: (value: any) => void;
  quickFilterChange?: (value: any) => void;
  onFilterChange?: (column: string, value: any) => void;
  onPageChange: (value: any) => void;
  onPageSizeChange?: (value: any) => void;
  onShowReservationsChange?: () => void;
  selectedRowId?: any;
  showReservations?: any;
  disableSearch?: boolean;
  isView?: boolean;
  hasPagination?: boolean;
  loadingTable?: boolean;
  reservationDialog?: any;
  paginationModel: any;
  rowCount: number;
  checkedRows?: any;
  changeCheckedRows?: () => void;
  changeAllCheckedRows?: (value: boolean) => void;
  sendChanges?: (value: boolean) => void;
  refreshTableData?: () => void;
  handleOpenFilters: () => void;
  progressPercent?: any;
  selectedGroupId?: any;
  apiRef?: any;
  handleDownloadMasterSettlementRiport?: () => void;
  setPopupState?: (value: any) => void;
  setFilterOriginalAndFinalPrice?: (value: any) => void;
  filterOriginalAndFinalPrice?: any;
  showDeleted?: any;
  setShowDeleted?: (value: any) => void;
  exportToXLSX?: () => void;
};

function CircularProgressWithLabel(
  props: CircularProgressProps & { value: number }
) {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress
        variant="determinate"
        value={100}
        size={props.size}
        thickness={props.thickness}
        sx={{
          color: '#c7c7c7',
          position: 'absolute',
        }}
      />
      <CircularProgress color={'success'} variant="determinate" {...props} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="caption"
          component="div"
          sx={{
            fontSize: '9px',
            color: 'text.secondary',
            fontWeight: 'bold',
          }}
        >{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
}

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.black, 0.05),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.black, 0.15),
  },
  marginLeft: 0,
  color: '#666',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(1),
    width: 'auto',
  },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: '0px 7px',
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  width: '100%',
  fontSize: '11px',
  '& .MuiInputBase-input': {
    padding: '7px 3px 7px 0px',
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(0px + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    [theme.breakpoints.up('sm')]: {
      width: '0px',
      '&:focus': {
        width: '100px',
      },
    },
  },
}));

type PaginationProps = {
  page: number;
  pageSize: number;
  rowCount: number;
  onPageChange: (newPage: number) => void;
  onPageSizeChange: (newSize: number) => void;
};

export const TableHeader = <T extends Entity>({
  schema,
  onEntityAdded,
  newEntityFixedValues,
  showCSVImport,
  fillOptions,
  fillOptionSend,
  rows,
  selectedRowId,
  setCurrentEditedRow,
  showReservations,
  setCurrentAddNewRow,
  onServiceProviderChange,
  onGuideFastSearchChange,
  onSalesPartnerSearchChange,
  onSearchChange,
  quickFilterChange,
  onFilterChange,
  disableSearch,
  handleOpenFilters,
  isView,
  hasPagination,
  paginationModel,
  rowCount,
  onPageSizeChange,
  onPageChange,
  onShowReservationsChange,
  checkedRows,
  changeCheckedRows,
  changeAllCheckedRows,
  loadingTable,
  sendChanges,
  reservationDialog,
  refreshTableData,
  progressPercent,
  selectedGroupId,
  apiRef,
  handleDownloadMasterSettlementRiport,
  filterOriginalAndFinalPrice,
  setFilterOriginalAndFinalPrice,
  showDeleted,
  setShowDeleted,
  setPopupState,
  exportToXLSX,
}: Props<T>): ReactElement => {
  const [addingEntity, setAddingEntity] = React.useState(false);
  const [open, setOpen] = React.useState<any>(false);
  const editedRow = rows
    ? rows.find((row: any) => {
        return row.id === selectedRowId?.id;
      })
    : [];
  const [data, setData] = React.useState(null);
  const elementRef = useRef<any>(null);
  const [base64Image, setBase64Image] = useState<any>(undefined);
  const [showSendNotification, setShowSendNotification] = useState(false);
  const [options, setOptions] = useState<any>([]);
  const [salesPartnerOptions, setSalesPartnerOptions] = useState<any>([]);
  const [guideOptions, setGuideOptions] = useState<any>([]);
  const [viewAgentOption, setViewAgentOption] = useState<any>(undefined);
  const [spOption, setSpOption] = useState<any>(undefined);
  const [guideOption, setGuideOption] = useState<any>(undefined);
  const [openFilterModal, setOpenFilterModal] = useState(false);
  const [progress, setProgress] = React.useState(0);

  const debouncedOnChangeFastFilter = debounce(
    handleDebouncedOnChangeFastFilter,
    500
  );

  function handleDebouncedOnChangeFastFilter(column: string, value: any) {
    if (onFilterChange) {
      onFilterChange(column, value);
    }
  }

  const debouncedOnChangeQuickFilter = debounce(
    handleDebouncedOnChangeQuickFilter,
    400
  );

  function handleDebouncedOnChangeQuickFilter(value: any) {
    if (quickFilterChange) {
      quickFilterChange(value);
    }
  }

  const ref = useRef<any>();

  useEffect(() => {
    let rowData: any = [];
    if (rows) {
      rows.map((dataItem: any) => {
        let row: any = {};

        Object.keys(dataItem).forEach(function (dataItemColumn, index) {
          let value = dataItem[`${dataItemColumn}`];

          if (
            dataItem[`${dataItemColumn}`] !== null &&
            typeof dataItem[`${dataItemColumn}`] === 'object'
          ) {
            if (dataItem[`${dataItemColumn}`].length) {
              let ids: number[] = [];

              dataItem[`${dataItemColumn}`].map((item: any) => {
                if (item?.id) {
                  ids.push(item.id);
                }
              });
              value = ids.join(',');
            } else {
              value =
                dataItem[`${dataItemColumn}`]?.id === undefined
                  ? null
                  : dataItem[`${dataItemColumn}`]?.id;
            }
          }
          row[`${dataItemColumn}`] = value;
        });

        rowData.push(row);
      });
    }

    setData(rowData);
  }, [rows]);

  const fetchBookingAgentOptions = useCallback(() => {
    return api.get('/admin/users-by-role/100/names').then((res: any) => {
      setOptions(res);
    });
  }, []);
  const fetchSalesPartnerOptions = useCallback(() => {
    return api.get('/sales-partners/names').then((res: any) => {
      setSalesPartnerOptions(res);
    });
  }, []);
  const fetchGuideOptions = useCallback(() => {
    return api.get('/admin/users-by-role/5/names').then((res: any) => {
      setGuideOptions(res);
    });
  }, []);

  const {
    user: { views },
    viewAgent,
  } = useStateContext();

  const [showBookingAgentFilter, setShowBookingAgentFilter] = useState<boolean>(
    false
  );

  const location = useLocation();
  useEffect(() => {
    if (ref?.current) {
      ref.current.value = '';
    }

    setShowBookingAgentFilter(false);

    if (
      location.pathname.includes('/groups') &&
      schema?.pluralName === 'Groups'
    ) {
      setShowBookingAgentFilter(true);
    }
  }, [schema]);

  const processedColumns = processColumns(schema.columns);

  const toDataURL = async (url: any) => {
    if (url) {
      const promise = new Promise((resolve, reject) => {
        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
          var reader = new FileReader();
          reader.readAsDataURL(xhr.response);
          reader.onloadend = function () {
            resolve({ base64Url: reader.result });
          };
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
      });

      return promise;
    }
  };

  const htmlToImageConvert = () => {
    const getName = (obj: any) => obj.name;
    const guideNames = editedRow?.guides.map(getName);

    toPng(elementRef.current, { cacheBust: false })
      .then((dataUrl) => {
        const link = document.createElement('a');
        link.download = `${editedRow?.name}-${guideNames.join('-')}-${
          editedRow?.arrival_date
        }.png`;
        link.href = dataUrl;
        link.click();

        setOpen(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getImageData = async () => {
    if (editedRow) {
      await toDataURL(editedRow?.sales_partner?.logo?.link).then(
        (data: any) => {
          setBase64Image(data?.base64Url);
        }
      );
    }
  };

  useEffect(() => {
    getImageData();
  }, [editedRow]);

  const handleOpenGetMeHome = () => {
    api
      .get(`/groups/${editedRow?.id}/reservations`)
      .then((res) => {
        setOpen(res);
      })
      .catch(() => {});
  };

  const generateSchedule = useCallback(() => {
    //setLoading(true);

    api
      .get(`/groups/${editedRow?.id}/reservations`)
      .then((res) => {
        exportGuideSchedule(res);
      })
      .finally(() => {
        //setLoading(false);
      });
  }, [editedRow]);

  const exportGuideSchedule = (group: any) => {
    const workbook = new ExcelJS.Workbook();
    const sheet: any = workbook.addWorksheet('Guide Schedule');

    sheet.pageSetup = {
      orientation: 'landscape',
      paperSize: 9,
    };
    sheet.pageSetup.fitToPage = true;

    sheet.pageSetup.margins = {
      left: 0.2,
      right: 0.2,
      top: 0.5,
      bottom: 0.5,
      header: 0.5,
      footer: 0.5,
    };

    sheet.pageSetup.printArea = 'A:O';

    // 147 max
    sheet.columns = [
      {
        header: '',
        key: 'row_number',
        width: 3,
      },
      {
        header: 'Activity',
        key: 'activity',
        width: 15,
      },
      {
        header: 'Guide',
        key: 'guide',
        width: 13,
      },
      {
        header: 'Provider',
        key: 'service_provider',
        width: 11,
      },
      {
        header: 'Size',
        key: 'group_size',
        width: 4,
      },
      {
        header: 'Date',
        key: 'date',
        width: 8,
      },
      {
        header: 'Meeting',
        key: 'meeting_time',
        width: 8,
      },
      {
        header: 'Pickup',
        key: 'pickup_time',
        width: 8,
      },
      {
        header: 'Pickup From',
        key: 'address_from',
        width: 18,
      },
      {
        header: 'Activity Start',
        key: 'start_time',
        width: 12,
      },
      {
        header: 'Activity Where',
        key: 'address_to',
        width: 18,
      },
      {
        header: 'Driver',
        key: 'driver',
        width: 18,
      },
      {
        header: 'Transfer',
        key: 'transfer',
        width: 18,
      },
      {
        header: 'Vehicle',
        key: 'vehicle',
        width: 18,
      },
      {
        header: 'Notes',
        key: 'notes',
        width: 18,
      },
    ];

    const promise = Promise.all(
      group.activity_reservations?.map(async (item: any, index: any) => {
        const rowNumber = index + 1;

        let driver = item?.driver?.name ? item?.driver.name : '-';
        if (item?.driver?.phone) {
          driver = `${driver} (${item?.driver?.phone})`;
        }

        let activityWhere = item.address_to?.name ? item.address_to?.name : '';
        if (item.address_to?.address_line1) {
          if (activityWhere === '') {
            activityWhere = item?.address_to?.address_line1;
          } else {
            activityWhere = `${activityWhere} (${item?.address_to?.address_line1})`;
          }
        }
        let pickupFrom = item.address_from?.name ? item.address_from?.name : '';
        if (item.address_from?.address_line1) {
          if (pickupFrom === '') {
            pickupFrom = item?.address_from?.address_line1;
          } else {
            pickupFrom = `${pickupFrom} (${item?.address_from?.address_line1})`;
          }
        }

        sheet.addRow(
          {
            row_number: rowNumber,
            activity: item?.activity?.name,
            service_provider: item?.activity_providers,
            group_size: item.group_size,
            guide: item.guides,
            date: item.date ? moment(item.date).format('YYYY-MM-DD ddd') : '',
            meeting_time: item?.meeting_time ? item?.meeting_time : '',
            pickup_time: item?.pickup_time ? item?.pickup_time : '',
            start_time: item?.start_time ? item?.start_time : '',
            address_from: pickupFrom,
            address_to: activityWhere,
            driver: driver,
            transfer: item?.transfer_providers,
            vehicle: item.vehicle?.name,
            notes: convert(item.guide_notes),
          },
          ''
        );
      })
    );
    const defaultSize = 9;

    const createOuterBorder = (
      worksheet: any,
      start = { row: 1, col: 1 },
      end = { row: 1, col: 1 },
      isTable = false
    ) => {
      for (let i = start.col; i <= end.col; i++) {
        worksheet.getCell(start.row, i).fill = {
          type: 'pattern',
          color: { argb: 'D9D9D9' },
        };

        for (let j = start.row; j <= end.row; j++) {
          worksheet.getCell(j, i).border = {
            top: { style: 'thin', color: { argb: '0000002B' } },
            left: { style: 'thin', color: { argb: '0000002B' } },
            bottom: { style: 'thin', color: { argb: '0000002B' } },
            right: { style: 'thin', color: { argb: '0000002B' } },
          };

          worksheet.getCell(j, i).font = {
            size: defaultSize,
          };

          worksheet.getCell(j, i).alignment = {
            wrapText: true,
            vertical: 'top',
            horizontal: 'left',
          };
        }
      }

      if (isTable) {
        for (let i = start.col; i <= end.col; i++) {
          const topBorderCell = worksheet.getCell(start.row, i);
          topBorderCell.font = {
            name: 'Roboto',
            family: 4,
            size: defaultSize,
            bold: true,
          };

          topBorderCell.alignment = {
            vertical: 'center',
            horizontal: 'center',
          };
        }
      }
    };

    createOuterBorder(
      sheet,
      { row: 1, col: 2 },
      { row: sheet.rowCount, col: sheet.columnCount },
      true
    );

    sheet.spliceRows(1, 0, []);
    sheet.spliceRows(1, 0, []);

    /* Group Info */
    sheet.spliceRows(1, 0, []);

    sheet.spliceRows(1, 0, []);
    sheet.spliceRows(1, 0, []);
    sheet.spliceRows(1, 0, []);
    sheet.spliceRows(1, 0, []);
    sheet.spliceRows(1, 0, []);

    // Empty line
    sheet.spliceRows(1, 0, []);

    /* Accommodation info */
    sheet.spliceRows(1, 0, []);

    sheet.spliceRows(1, 0, []);
    sheet.spliceRows(1, 0, []);
    sheet.spliceRows(1, 0, []);
    sheet.spliceRows(1, 0, []);
    sheet.spliceRows(1, 0, []);

    // Empty line
    sheet.spliceRows(1, 0, []);

    /* Flight info */
    sheet.spliceRows(1, 0, []);

    sheet.spliceRows(1, 0, []);
    sheet.spliceRows(1, 0, []);

    // Empty line
    sheet.spliceRows(1, 0, []);

    const accommodations = group?.bookings;
    /*accommodations.map((acc, index) => {
      sheet.spliceRows(1, 0, []);
    });*/
    sheet.spliceRows(1, 0, []);

    sheet.getCell('B1').value = `GUIDE SCHEDULE`;
    sheet.getCell('B2').value = '';

    /* Group info */

    sheet.getCell('B3').value = 'Group Info';

    sheet.mergeCells('B1:C1');
    sheet.mergeCells('B2:C2');
    sheet.mergeCells('B3:C3');

    sheet.getCell('B4').value = `GROUP: ${
      group?.name ? `${group?.name}(${group?.phone ? group?.phone : '-'})` : '-'
    }`;
    sheet.getCell('B5').value = `Arrival: ${
      group?.arrival_date ? group?.arrival_date : '-'
    }`;
    sheet.getCell('B6').value = `Group size: ${
      group?.size ? group?.size : '-'
    }`;
    sheet.getCell('B7').value = `Sales Partner Hotline: ${
      group?.sales_partner?.hotline ? group?.sales_partner?.hotline : '-'
    }`;
    sheet.getCell('B8').value = `Booking Manager Name - Partner: ${
      group?.sales_agent?.name ? group?.sales_agent?.name : '-'
    }`;

    for (let i = 4; i < 9; i++) {
      sheet.mergeCells(`B${i}:C${i}`);
    }

    sheet.getCell('D4').value = `Stag name: ${
      group?.stag_name ? group?.stag_name : '-'
    }`;
    sheet.getCell('D5').value = `Departure: ${
      group?.departure_date
        ? moment(group?.departure).format('YYYY-MM-DD ddd')
        : '-'
    }`;
    sheet.getCell('D6').value = `Sales partner: ${
      group?.sales_partner?.name ? group?.sales_partner?.name : '-'
    }`;
    sheet.getCell('D7').value = '';
    sheet.getCell('D8').value = `Booking Manager Name - Travel City: ${
      group?.booking_agent?.name ? group?.booking_agent?.name : '-'
    }`;

    for (let i = 4; i < 9; i++) {
      sheet.mergeCells(`D${i}:H${i}`);
    }

    sheet.getCell('I4').value = `Country: ${
      group?.country ? group?.country : '-'
    }`;
    sheet.getCell('I5').value = `Language: ${
      group?.language?.name ? group?.language?.name : '-'
    }`;

    for (let i = 4; i < 9; i++) {
      sheet.mergeCells(`I${i}:K${i}`);
    }

    sheet.getCell('B9').value = '';

    /* Accommodation info */

    sheet.mergeCells(`B10:C10`);
    sheet.getCell('B10').value = 'Accommodation Info';

    const accom: any = accommodations?.[0] ? accommodations[0] : null;
    let differenceInDays = '-';
    if (accom?.arrival && accom?.departure) {
      const dep: any = new Date(accom?.departure);
      const arr: any = new Date(accom?.arrival);

      const differenceInTime: any = dep - arr;
      differenceInDays = `${differenceInTime / (1000 * 60 * 60 * 24)} nights`;
    }

    sheet.getCell('B11').value = `Accommodation: ${
      accom?.accommodation?.name ? accom?.accommodation?.name : '-'
    }`;
    sheet.getCell('B12').value = `Checkin: ${
      accom?.checkin_time ? moment(accom?.checkin_time).format('HH:mm') : '-'
    }`;
    sheet.getCell('B13').value = `Accommodation Hotline: ${
      accom?.accommodation?.hotline ? accom?.accommodation?.hotline : '-'
    }`;
    sheet.getCell('B14').value = `Accommodation Booked: ${differenceInDays}`;
    sheet.getCell('B15').value = `Apartment allocation: `;

    for (let i = 11; i < 16; i++) {
      sheet.mergeCells(`B${i}:C${i}`);
    }

    const addresses = accom?.accommodation?.addresses.map((addr: any) => {
      let name = '';
      if (addr?.name) {
        name = addr?.name;
        if (addr?.address_line1) {
          name = `${name} (${addr?.address_line1})`;
        }
      } else {
        name = addr?.address_line1;
      }

      return name;
    });

    sheet.getCell('D11').value = `Accommodation address: ${
      addresses ? addresses.join(',') : '-'
    }`;
    sheet.getCell('D12').value = `Checkout: ${
      accom?.checkout_time ? moment(accom?.checkout_time).format('HH:mm') : '-'
    }`;
    sheet.getCell('D13').value = ``;
    sheet.getCell('D14').value = `From: ${
      accom?.arrival ? moment(accom?.arrival).format('YYYY-MM-DD ddd') : '-'
    }`;

    for (let i = 11; i < 14; i++) {
      sheet.mergeCells(`D${i}:H${i}`);
    }

    sheet.mergeCells(`D14:E14`);
    sheet.mergeCells(`F14:H14`);

    sheet.getCell('F14').value = `To: ${
      accom?.departure ? moment(accom?.departure).format('YYYY-MM-DD ddd') : '-'
    }`;

    for (let i = 15; i < 16; i++) {
      sheet.mergeCells(`D${i}:H${i}`);
    }

    sheet.getCell('I11').value = `Booked By: ${
      accom?.booked_by?.name ? accom?.booked_by?.name : '-'
    }`;
    sheet.getCell('I12').value = `Accommodation needs IDs from group: yes / no`;
    sheet.getCell('I13').value = `Who has to send IDs: Group / Travel City`;
    sheet.getCell('I14').value = accom?.confirm_file?.url
      ? accom?.confirm_file?.url
      : '-';
    sheet.getCell('I15').value = ``;

    for (let i = 11; i < 16; i++) {
      sheet.mergeCells(`I${i}:K${i}`);
    }

    sheet.getCell('B16').value = '';

    /* Flight info */

    sheet.mergeCells(`B17:C17`);
    sheet.getCell('B17').value = 'Flight Info';

    sheet.getCell('B18').value = `Arrival: ${
      group?.arrival_date
        ? moment(group?.arrival_date).format('YYYY-MM-DD ddd')
        : '-'
    }`;
    sheet.getCell('B19').value = `Flight no.: ${
      group?.arrival_flight?.name ? group?.arrival_flight?.name : '-'
    }`;

    for (let i = 18; i < 20; i++) {
      sheet.mergeCells(`B${i}:C${i}`);
    }

    sheet.getCell('D18').value = `Departure: ${
      group?.departure_date
        ? moment(group?.departure_date).format('YYYY-MM-DD ddd')
        : '-'
    }`;
    sheet.getCell('D19').value = `Flight no.: ${
      group?.departure_flight?.name ? group?.departure_flight?.name : '-'
    }`;

    for (let i = 18; i < 20; i++) {
      sheet.mergeCells(`D${i}:H${i}`);
    }

    sheet.getCell('B20').value = '';
    sheet.mergeCells(`B21:C21`);
    sheet.getCell('B21').value = 'Activities';

    /* Accommodations */

    sheet.eachRow(function (row: any, rowNum: number) {
      row.eachCell(function (cell: any, cellNum: number) {
        cell.alignment = {
          vertical: 'middle',
          wrapText: true,
        };

        if (cell?.row > 21) {
          if (
            cell._column.key === 'meeting_time' ||
            cell._column.key === 'pickup_time' ||
            cell._column.key === 'address_from'
          ) {
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'F3F3F3' },
            };
          }

          if (
            cell._column.key === 'address_to' ||
            cell._column.key === 'start_time'
          ) {
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'D9D9D9' },
            };
          }
        }

        if (cell?.row > 21) {
          if (
            cell._column._key === 'start_time' ||
            cell._column._key === 'pickup_time' ||
            cell._column._key === 'meeting_time' ||
            cell._column._key === 'group_size'
          ) {
            cell.alignment = {
              vertical: 'middle',
              horizontal: 'center',
              wrapText: true,
            };
          }
        }
      });
    });

    const getName = (obj: any) => obj.name;
    const guideNames: any = group?.guides.map(getName);

    const createOuterBorder1 = (worksheet: any, start: any, end: any) => {
      // Bal oszlop (függőleges bal szegély)
      for (let row = start.row; row <= end.row; row++) {
        const cell = worksheet.getCell(row, start.col);
        cell.border = {
          ...cell.border, // Megtartja a meglévő szegélyeket
          left: { style: 'thin', color: { argb: '000000' } }, // Jobb szegély hozzáadása
        };
      }

      // Jobb oszlop (függőleges jobb szegély)
      for (let row = start.row; row <= end.row; row++) {
        const cell = worksheet.getCell(row, end.col);
        cell.border = {
          ...cell.border, // Megtartja a meglévő szegélyeket
          right: { style: 'thin', color: { argb: '000000' } }, // Jobb szegély hozzáadása
        };
      }

      // Felső sor (vízszintes felső szegély)
      for (let col = start.col; col <= end.col; col++) {
        const cell = worksheet.getCell(start.row, col);
        cell.border = {
          ...cell.border, // Megtartja a meglévő szegélyeket
          top: { style: 'thin', color: { argb: '000000' } }, // Jobb szegély hozzáadása
        };
      }

      // Alsó sor (vízszintes alsó szegély)
      for (let col = start.col; col <= end.col; col++) {
        const cell = worksheet.getCell(end.row, col);
        cell.border = {
          ...cell.border, // Megtartja a meglévő szegélyeket
          bottom: { style: 'thin', color: { argb: '000000' } }, // Jobb szegély hozzáadása
        };
      }
    };

    createOuterBorder1(sheet, { row: 4, col: 2 }, { row: 8, col: 11 });
    createOuterBorder1(sheet, { row: 11, col: 2 }, { row: 15, col: 11 });
    createOuterBorder1(sheet, { row: 18, col: 2 }, { row: 19, col: 11 });

    for (let i = 1; i < 100; i++) {
      sheet.getRow(i).font = {
        name: 'Roboto',
        family: 4,
        size: defaultSize,
      };
    }

    //Headers
    sheet.getCell('B1').font = {
      name: 'Roboto',
      family: 4,
      size: 14,
      bold: true,
    };
    sheet.getCell('B3').font = {
      name: 'Roboto',
      family: 4,
      size: defaultSize,
      bold: true,
    };
    sheet.getCell('B10').font = {
      name: 'Roboto',
      family: 4,
      size: defaultSize,
      bold: true,
    };
    sheet.getCell('B17').font = {
      name: 'Roboto',
      family: 4,
      size: defaultSize,
      bold: true,
    };
    sheet.getCell('B21').font = {
      name: 'Roboto',
      family: 4,
      size: defaultSize,
      bold: true,
    };

    const mergedCells: any = {};
    sheet.eachRow((row: any) => {
      row.eachCell((cell: any) => {
        const merge = sheet._merges[cell.address]; // Ellenőrizzük, hogy a cella egy merge része-e
        if (merge) {
          const mergeRange = merge.model; // Merge tartomány modellje

          // Bejárjuk az egyesített tartomány összes celláját
          for (
            let rowNum = mergeRange.top;
            rowNum <= mergeRange.bottom;
            rowNum++
          ) {
            for (
              let colNum = mergeRange.left;
              colNum <= mergeRange.right;
              colNum++
            ) {
              const cellName = `${String.fromCharCode(64 + colNum)}${rowNum}`; // Cellanév például "A1"
              mergedCells[cellName] = true; // Hozzáadjuk az egyesített cellák listájához
            }
          }
        }
      });
    });

    sheet.eachRow((row: any) => {
      let maxLines = 1;

      if (row._number > 22) {
        row.eachCell((cell: any) => {
          if (cell.value && typeof cell.value === 'string') {
            const lineCount = Math.ceil(cell.value.length / cell._column.width);
            maxLines = Math.max(maxLines, lineCount);
          }
        });
        row.height = maxLines * 12;
      }

      if (row._number < 22) {
        let maxLines = 1;
        const processedCells = new Set(); // Nyomon követjük a már feldolgozott cellákat

        row.eachCell((cell: any) => {
          const merge = sheet._merges[cell.address];
          if (merge) {
            const range = merge.model;
            const masterCell = `${range.top}:${range.left}`;

            if (processedCells.has(masterCell)) {
              return;
            }
            processedCells.add(masterCell);

            let totalWidth = 0;
            for (let i = range.left; i <= range.right; i++) {
              totalWidth += sheet.getColumn(i).width || 10;
            }

            if (cell.value && typeof cell.value === 'string') {
              const lineCount = Math.ceil(cell.value.length / totalWidth);
              maxLines = Math.max(maxLines, lineCount);
            }
          } /*else{

            if (cell.value && typeof cell.value === 'string') {
              if (!mergedCells[cell._address]){
                const lineCount = Math.ceil(cell.value.length / cell._column.width);
                maxLines = Math.max(maxLines, lineCount);
              }
            }
          }*/
        });

        row.height = maxLines * 12;
      }
    });

    sheet.getRow(15).height = 24;
    sheet.getRow(22).eachCell(function (cell: any, cellNum: any) {
      cell.font = {
        name: 'Roboto',
        family: 4,
        size: defaultSize,
        bold: true,
      };
    });

    /*
    Airport Card start
     */

    const sheetAirPortCard = workbook.addWorksheet('Airport Card');

    sheetAirPortCard.pageSetup = {
      orientation: 'landscape',
      paperSize: 9,
    };

    sheetAirPortCard.pageSetup.margins = {
      left: 0.5,
      right: 0.5,
      top: 0.5,
      bottom: 0.5,
      header: 0.5,
      footer: 0.5,
    };

    sheetAirPortCard.pageSetup.fitToPage = true;

    const splitted = editedRow?.sales_partner?.logo?.link.split('.');

    const extName = splitted ? splitted[splitted.length - 1] : 'png';

    sheetAirPortCard.columns = [
      {
        width: 147,
      },
      {
        width: 147,
      },
    ];

    const imageCell = sheetAirPortCard.getCell('A1');
    imageCell.alignment = {
      horizontal: 'center',
      vertical: 'middle',
    };

    const firstRow = sheetAirPortCard.getRow(1);
    firstRow.height = 400;

    const imageId2 = workbook.addImage({
      base64: base64Image
        ? base64Image
        : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA4QAAAIcCAYAAACuDGChAAAKQ2lDQ1BJQ0MgcHJvZmlsZQAAeNqdU3dYk/cWPt/3ZQ9WQtjwsZdsgQAiI6wIyBBZohCSAGGEEBJAxYWIClYUFRGcSFXEgtUKSJ2I4qAouGdBiohai1VcOO4f3Ke1fXrv7e371/u855zn/M55zw+AERImkeaiagA5UoU8Otgfj09IxMm9gAIVSOAEIBDmy8JnBcUAAPADeXh+dLA//AGvbwACAHDVLiQSx+H/g7pQJlcAIJEA4CIS5wsBkFIAyC5UyBQAyBgAsFOzZAoAlAAAbHl8QiIAqg0A7PRJPgUA2KmT3BcA2KIcqQgAjQEAmShHJAJAuwBgVYFSLALAwgCgrEAiLgTArgGAWbYyRwKAvQUAdo5YkA9AYACAmUIszAAgOAIAQx4TzQMgTAOgMNK/4KlfcIW4SAEAwMuVzZdL0jMUuJXQGnfy8ODiIeLCbLFCYRcpEGYJ5CKcl5sjE0jnA0zODAAAGvnRwf44P5Dn5uTh5mbnbO/0xaL+a/BvIj4h8d/+vIwCBAAQTs/v2l/l5dYDcMcBsHW/a6lbANpWAGjf+V0z2wmgWgrQevmLeTj8QB6eoVDIPB0cCgsL7SViob0w44s+/zPhb+CLfvb8QB7+23rwAHGaQJmtwKOD/XFhbnauUo7nywRCMW735yP+x4V//Y4p0eI0sVwsFYrxWIm4UCJNx3m5UpFEIcmV4hLpfzLxH5b9CZN3DQCshk/ATrYHtctswH7uAQKLDljSdgBAfvMtjBoLkQAQZzQyefcAAJO/+Y9AKwEAzZek4wAAvOgYXKiUF0zGCAAARKCBKrBBBwzBFKzADpzBHbzAFwJhBkRADCTAPBBCBuSAHAqhGJZBGVTAOtgEtbADGqARmuEQtMExOA3n4BJcgetwFwZgGJ7CGLyGCQRByAgTYSE6iBFijtgizggXmY4EImFINJKApCDpiBRRIsXIcqQCqUJqkV1II/ItchQ5jVxA+pDbyCAyivyKvEcxlIGyUQPUAnVAuagfGorGoHPRdDQPXYCWomvRGrQePYC2oqfRS+h1dAB9io5jgNExDmaM2WFcjIdFYIlYGibHFmPlWDVWjzVjHVg3dhUbwJ5h7wgkAouAE+wIXoQQwmyCkJBHWExYQ6gl7CO0EroIVwmDhDHCJyKTqE+0JXoS+cR4YjqxkFhGrCbuIR4hniVeJw4TX5NIJA7JkuROCiElkDJJC0lrSNtILaRTpD7SEGmcTCbrkG3J3uQIsoCsIJeRt5APkE+S+8nD5LcUOsWI4kwJoiRSpJQSSjVlP+UEpZ8yQpmgqlHNqZ7UCKqIOp9aSW2gdlAvU4epEzR1miXNmxZDy6Qto9XQmmlnafdoL+l0ugndgx5Fl9CX0mvoB+nn6YP0dwwNhg2Dx0hiKBlrGXsZpxi3GS+ZTKYF05eZyFQw1zIbmWeYD5hvVVgq9ip8FZHKEpU6lVaVfpXnqlRVc1U/1XmqC1SrVQ+rXlZ9pkZVs1DjqQnUFqvVqR1Vu6k2rs5Sd1KPUM9RX6O+X/2C+mMNsoaFRqCGSKNUY7fGGY0hFsYyZfFYQtZyVgPrLGuYTWJbsvnsTHYF+xt2L3tMU0NzqmasZpFmneZxzQEOxrHg8DnZnErOIc4NznstAy0/LbHWaq1mrX6tN9p62r7aYu1y7Rbt69rvdXCdQJ0snfU6bTr3dQm6NrpRuoW623XP6j7TY+t56Qn1yvUO6d3RR/Vt9KP1F+rv1u/RHzcwNAg2kBlsMThj8MyQY+hrmGm40fCE4agRy2i6kcRoo9FJoye4Ju6HZ+M1eBc+ZqxvHGKsNN5l3Gs8YWJpMtukxKTF5L4pzZRrmma60bTTdMzMyCzcrNisyeyOOdWca55hvtm82/yNhaVFnMVKizaLx5balnzLBZZNlvesmFY+VnlW9VbXrEnWXOss623WV2xQG1ebDJs6m8u2qK2brcR2m23fFOIUjynSKfVTbtox7PzsCuya7AbtOfZh9iX2bfbPHcwcEh3WO3Q7fHJ0dcx2bHC866ThNMOpxKnD6VdnG2ehc53zNRemS5DLEpd2lxdTbaeKp26fesuV5RruutK10/Wjm7ub3K3ZbdTdzD3Ffav7TS6bG8ldwz3vQfTw91jicczjnaebp8LzkOcvXnZeWV77vR5Ps5wmntYwbcjbxFvgvct7YDo+PWX6zukDPsY+Ap96n4e+pr4i3z2+I37Wfpl+B/ye+zv6y/2P+L/hefIW8U4FYAHBAeUBvYEagbMDawMfBJkEpQc1BY0FuwYvDD4VQgwJDVkfcpNvwBfyG/ljM9xnLJrRFcoInRVaG/owzCZMHtYRjobPCN8Qfm+m+UzpzLYIiOBHbIi4H2kZmRf5fRQpKjKqLupRtFN0cXT3LNas5Fn7Z72O8Y+pjLk722q2cnZnrGpsUmxj7Ju4gLiquIF4h/hF8ZcSdBMkCe2J5MTYxD2J43MC52yaM5zkmlSWdGOu5dyiuRfm6c7Lnnc8WTVZkHw4hZgSl7I/5YMgQlAvGE/lp25NHRPyhJuFT0W+oo2iUbG3uEo8kuadVpX2ON07fUP6aIZPRnXGMwlPUit5kRmSuSPzTVZE1t6sz9lx2S05lJyUnKNSDWmWtCvXMLcot09mKyuTDeR55m3KG5OHyvfkI/lz89sVbIVM0aO0Uq5QDhZML6greFsYW3i4SL1IWtQz32b+6vkjC4IWfL2QsFC4sLPYuHhZ8eAiv0W7FiOLUxd3LjFdUrpkeGnw0n3LaMuylv1Q4lhSVfJqedzyjlKD0qWlQyuCVzSVqZTJy26u9Fq5YxVhlWRV72qX1VtWfyoXlV+scKyorviwRrjm4ldOX9V89Xlt2treSrfK7etI66Trbqz3Wb+vSr1qQdXQhvANrRvxjeUbX21K3nShemr1js20zcrNAzVhNe1bzLas2/KhNqP2ep1/XctW/a2rt77ZJtrWv913e/MOgx0VO97vlOy8tSt4V2u9RX31btLugt2PGmIbur/mft24R3dPxZ6Pe6V7B/ZF7+tqdG9s3K+/v7IJbVI2jR5IOnDlm4Bv2pvtmne1cFoqDsJB5cEn36Z8e+NQ6KHOw9zDzd+Zf7f1COtIeSvSOr91rC2jbaA9ob3v6IyjnR1eHUe+t/9+7zHjY3XHNY9XnqCdKD3x+eSCk+OnZKeenU4/PdSZ3Hn3TPyZa11RXb1nQ8+ePxd07ky3X/fJ897nj13wvHD0Ivdi2yW3S609rj1HfnD94UivW2/rZffL7Vc8rnT0Tes70e/Tf/pqwNVz1/jXLl2feb3vxuwbt24m3Ry4Jbr1+Hb27Rd3Cu5M3F16j3iv/L7a/eoH+g/qf7T+sWXAbeD4YMBgz8NZD+8OCYee/pT/04fh0kfMR9UjRiONj50fHxsNGr3yZM6T4aeypxPPyn5W/3nrc6vn3/3i+0vPWPzY8Av5i8+/rnmp83Lvq6mvOscjxx+8znk98ab8rc7bfe+477rfx70fmSj8QP5Q89H6Y8en0E/3Pud8/vwv94Tz+4A5JREAAAAZdEVYdFNvZnR3YXJlAEFkb2JlIEltYWdlUmVhZHlxyWU8AAADKGlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdFJlZj0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlUmVmIyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ0MgMjAxNyAoTWFjaW50b3NoKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo1M0FBNUZFRkQ1Q0YxMUU2QURDQkM0N0NGQTQ0NjAzRCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo1M0FBNUZGMEQ1Q0YxMUU2QURDQkM0N0NGQTQ0NjAzRCI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjUzQUE1RkVERDVDRjExRTZBRENCQzQ3Q0ZBNDQ2MDNEIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjUzQUE1RkVFRDVDRjExRTZBRENCQzQ3Q0ZBNDQ2MDNEIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+SpksZgAAQWxJREFUeNrs3Qm8HFWdL/ATkUXAJaiIG2JABNnU4L49neAwuC/BBWee89TE3RnxvcRlRlwnGUVHXJC4zogbV3AdlyE6Ou5KVEBQES4oKihKUPY173+oanMT7+2q6tt9u7r7+/18/p8oVbe7+nRVd/26Tp2zaNOmTQkAAIDJcxNNAAAAIBACAAAgEAIAACAQAgAAIBACAAAgEAIAACAQAgAAIBACAAAgEAIAACAQAgAAIBACAAAgEAIAACAQAgAAIBACAAAgEAIAACAQAgAAIBACAAAgEAIAACAQAgAAIBACAAAgEAIAACAQAgAAIBACAAAgEAIAAAiEAAAACIQAAAAIhAAAAAiEAAAACIQAAAAIhAAAAAiEAAAACIQAAAAIhAAAAAiEAAAACIQAAAAIhAAAAAiEAAAACIQAAAAIhAAAAAiEAAAACIQAAAAIhAAAAAiEAAAACIQAAAAIhAAAAAiEAAAACIQAAAACIQAAAAIhAAAAAiEAAAACIQAAAAIhAAAAAiEAAAACIQAAAAIhAAAAAiEAAAACIQAAAAIhAAAAAiEAAAACIQAAAAIhAAAAAiEAAAACIQAAAAIhAAAAAiEAAAACIQAAAAIhAAAAAiEAAAACIQAAAAIhAAAAAiEAAIBACAAAgEAIAACAQAgAAIBACAAAgEAIAACAQAgAAIBACAAAgEAIAACAQAgAAIBACAAAgEAIAACAQAgAAIBACAAAgEAIAACAQAgAAIBACAAAgEAIAACAQAgAAIBACAAAgEAIAABAdzfVBAD9cdTRb9EIsNDH3ZEv1QgAAiEAY2K3qMOiHhh1j6i7Rt0iaseojVG/jzon6pSor5V1rWYDAIEQgNH9Lnpi1HOjHpbmvp1hcVl3izo06lVlSDw+6h1RZ2lKAGjGPYQADNNjo06L+njUw3v4XsoB8UVRZ0Z9IBVXGAEAgRCAFstB7oSoT0ft24fH2ybqmVE/ifpbzQsAAiEA7bR/1Iao5QN47FtF/UfUu8qQCAAIhAC0xH1SMRDMXQf8PM+LmoraTpMDgEAIwPDtF/WfUbss0PM9Ier9UYs0PQAIhAAMT5464qSo2zb8u01Rv406N+ryHp73iKiXa34AEAgBGJ5jovauuW6eSuItUY+M2ikVI4cuido56o5RT4/6XNQNNR/vtVEHewsAQCAEYOE9Iurvaqx3VSrmFrxL1JFRJ0ddudU6v4n6aNRjou4Z9Z0aj5sHl1nnOw8ABEIAFla+f29Nqr6P7/yo+0W9IerSmo99etRDol5fY917paL7KAAgEAKwQPLVwftUrPOrqAenYoL6pq6L+qdU7z7Bl3k7AEAgBGDhPLdGoMvzEf5yns+Tr0KeWLHOgVEP9JYAgEAIwODlAWEeVbHOO1K9+wDreE7UJRXrPNnbAgACIQCD99Com3VZfnXUv/bx+fLopMdUrHOYtwUABEIABu/+FctzF88L+vycx6bu01HcPepW3hoAEAgBGKy7Vyz/wgCe88KoH1Wss4+3BgAEQgAG684Vy380oOc9Y57bBQACIQDM080rll84oOe9aJ7bBQACIQAM2E0H9Lg3+O4DAIEQgOG6vGL5bgN63ttULL/UWwMAAiEAg1U12fygBnc5qGL5+d4aABAIARissyqWP3IAz7lr1D3nuV0AIBACwDx9s2L58tT/AV6eEbWoy/Kzo37vrQEAgRCAwfpW1DVdlu8c9dI+Pl8Oly+rWOeL3hYAEAgBGLw/Rf1XxTqro/br0/O9Ler2Fevs5G0BAIEQgIXxnorlO0R9KuqO83yeZ0f9fY318jov8LYAgEAIwOB9LuqMinX2ivpq1JIeHj/fL/gPUe9u8Df5SuIh3hoAEAgBGKw8SfyqGuvlULgh6jmp/oT1d4n6TNRbo7ZpsE153amofb09AAiEADBY/xn12Rrr3SpqXdSZUUdG3X2WdXaMWhb1H1E/j3p0j9t0yzJM3tbbA8Aku6kmAKBl3zd3i3pzWZdE/aL87zm87drH7658VfLjUYem7qOhAoAvaADo0e1S7/fs3aqsQXl41LtSMSgNAEwcXUYBGLSnpuH8APmVqO/XWO9ZqXr+QgAQCAGgB387hOc8IepRUU+M+lWN9ddEPdZbBYBACAD9c4+opQv4fFdFvTQVVyWvKsPgE6KuqPi7PPLoh6IO8JYBIBACQH88o2L5b6Mu6NNzfSHqoFRMQ7Fpxn8/Jervtvpvs7lFKuZNNPIoAAIhAPThO+bpFeu8NxWjfb4w6tQenuPqVHQPfUDUYVFnzbHeiVGvqvF4u6diioztvH0ATAKjjAIwKA9JxeTx3eRumrk75zvLynMP5i6eD4raP2q3qB1mrL8xajoVg8V8LeqLqZiaoo5/SUUX1iMq1rtf1PtTce/jJm8jAAIhADRXNZjM96J+ttV/y/9/zVb/LQfCm5XB8ep5bE8Od3lE0b3K0NdNDo1nlCESAMaWLqMADEIOccsr1jm+5mPlwWE2zjMMduTHeEzU+TXWfUMqRikFAIEQABrIUzjcosvya6M+PqRtuygVU1JcWrHeolR0aV3q7QRAIASA+qpGF/1S1O+GuH2nl9t4fcV6O0Z9KupO3lIABEIAqJanbTi0Yp3jW7Cdn4l6RY31chg8sQyHACAQAkAXT4natsvyP5VhrA3+NeoDNda7b9QHU9GNFAAEQgCYQ9Xoop+IurJF2/vcVExhUSUPkvNaby8AAiEAzG7vVFxN6+ZDLdvma8qwd3aNdV+ZqucxBACBEICJVHV1ME/38D8t3O488ujjo/5YsV7uMvqeVD2PIQAIhABMlByWqq6efTjqhpZuf56IPt//WDXy6M1ScQ+kkUcBEAgBoPSgqLtWrPOhlr+GPB3GP9RYb9eoz0ft5G0HQCAEgOruoj+IOnMEXsc7oo6tsd4BUR+J2sZbD4BACMAk2z4VA7N0c/wIvZ4XR32lxnqPjXqDtx8AgRCASfboqMVdll8X9dERej15e58Y9fMa666KeqZdAACBEIBJ9YyK5eujLhyx15RHHD0s6uIa6x4X9VC7AQACIQCTZpcyOHXzoRF9bXluwtwV9pqK9baL+kTUXnYHAARCACbJU8pANJdLoz49wq8v30v44hrr3Tbqk1G3tEsAIBACMCmqRhfNIenyEX+NuUvov9VYb/+ojyUjjwIgEAIwAfaMun/FOh8ak9f6sqj/rLHeoVFvtWsAIBACMO7yYDKLuiz/Tao3fcMouD7qiKjTa6z7oqjn2T0AEAgBGFeLUvXooh+OumGMXnMeefTxURfVWPdtUY+wmwAgEAIwjnJX0apRNY8fw9c9HfWEVD3y6LZRJyUjjwIgEAIwhqoGkzk16rQxfe3fjHp2jfXyiKNfiFpsdwGgjW6qCQDoQZ5m4vCKdY4f8zbIg+XcI2p1xXr5CmGeo/BvUvVVxYWwa9TOUTcvzwM2Rl0Z9fuoa+3aAAIhAFTJ4ebWXZbn+wY/MgHt8IoyFD62Yr18L2G+p3ChBprJ3+97p2IajAPKf+8WtSTqZl3es19F/TTqu2V9IxX3TQIgEALAn1V1F/1yKkYYHXebop4W9a2ogyrWfW4Ztt7W522481bB74AypG7X8HHybSS7l/XI8r/lK5p5lNgTo6aEQwCBEABuFfXoinU+NEHtcUXZHt+Lun3FukdH/Tzq8z22+/5lHRi1X/nvrQb42nKoPLSsY1LRDTjPsfgThwGAQAjAZMr3Dm7fZfnlUZ+csDbJXS3zyKP5atqOXdbbJhVdaR+S5p7PMIewfdPmq30HlOHvLkN+jbmr6XOinhX10ah/ijrX4QAgEAIwWarmHvxU1GUT2C75nrs88miee3FRl/VuWQbmB0btNCP4HVj+73zv37Ytfp25a+kRUU+Mel3Um5PBaAAEQgAmwl2jHlyxzvET3D75ytndo15dsd6eqbjHcpsRfq35iuEbo54a9ZRU3B8JwIgxDyEATTw9db/6dWHUyRPcPjtEfS4V9wlW2WZMXnO+svn9VFw1BGDEuEIIQBNVo4vm++Oun4B2yD+oLinD0MzRPfdqedDL8w1OR12Qim6916ViUJrF5etZ3OPj5nkNjy/bIU/FscmhAiAQAjBe7puK7pDdjGN30dulzYO7dCpP67Bji7c539OXu3CeXtaPyzqv4u92i3pA1LJUzK14p4bPuzrqNlErhEIAgRCA8VJ1dfCMqB+O8OvbuQx6ncFdOgO93Kbl233ejMB3avk+/DT1NtBL7vL7ybJeGPWIqOdHPT7Vv80kD6yT5y98gUMGQCAEYDzkUS8Pr1hnVOYezN99e6ctJ3PPwS8PmLOoxdt9cdp8tS//e1oZ/v40oOfLV/i+XFZuo9dHPa7m3+YQ+ftUPbgOAAIhACPgr6N27bL8hlTcP9g2d0qbu3l2JnXPVwG3b3FbXxV1Ztp81e+0MgD+ZojblLcjXyV8TNS7o+5Q42/yPIX5iuVJDh8AgRCA0VY19+DXos4f4vbdMm3ZzXO/8n8vbnGb5hB9btrczbNzv9/ZqRjspY0+G/WdVNwr+siKdfPV1veXYfIshxCAQAjAaLpFqu4quFDdRbeL2meW8HeXlrfh79KWg7vkEJivAl4+gvvDRVGHRR2Tiq6hVUH9A1EPKQMwAAIhACPmyamYX28uV0Sd2OfnzFeX9kibu3l2pnfI9/5t2+K2ym2Rr/Z17u/rXPX77ZjtE3lqkReUgfb/Vqz7wFQMUHOMQwlAIARg9FSNLpq7Ec5nYJNdog5Km7t5du73u3nLA9HZacvBXfK/eY6/SboS9v9SMTrr8yrWe13Ux8cwGAMIhACMtd2jHlqxTt3uovkqY2dah/3S5ukd7tDyNsiDucwc3CX/79zd8yq7x41eXL6f3faT3O34VVEv0lwAAiEAo+OI1H3+uXxv3Je2+m95/SVpczfPzv1+e0Vt0+LXmq9yzuzm2QmBF9sNusoD4DylbLtduqz3nKg3Rl2gyQAEQgBGQ9XooidH/a+05Xx++Srgji1+TXnC9p/NCHydgV7O9Xb3LE9o/49R/95lnTzVx7NSMZ8hAAIhAC137zLcdXNEWW31i7R5IvfOVb+fRl3j7e273HU430t4/y7r5FFJ15ahHACBEICWyV06c9fOfMXv/4zQdm8sA1/utnhq2nzV74/e0gWzKWp11Fe7rHP7VFxRPllzAQiEAAxXHsyl082zM8hLviK4Q4u3+epUDOjSCXydLp+/8na2wteifhh1ry7rPEkgBBAIAVg4N0+bB3Y5YEb4u3WLtzlfbcpTOHS6eXb+PSsVg5jQXu+Iel+X5Y+Jeq5mAhAIAeivPGH73mX4OyhtntR9j1RM9N5Wv09bTumQ/3e+CniZt3QkfTLq3eX+OJt8ZXrfqJ9oKgCBEIDe3CVtnsi9M5/fPlHbtXibryiD3ulblcnKx0u+n/PrUY/oss79BEIAgRCA+p/VD4p6WNQDUjGK461avL3XR52dNl/xy5UHesldQG/wdk6E/6kIhPkeww9qJgCBEIC55fD37KgnRC1u6TZeUAa/3M2zM6l7/vcqb99E+3bF8oM0EYBACMBfukkqJoN/SSrmAWyLS8ugd9qM0Jf/9x+8ZczitIrlB2giAIEQgC09PuoNqXoy+EHKI3j+LG0e3KVz1e/cVIz8CXVcGHVR1G3nWL5L1B2jfq2pAARCgEl3p1SMyvioBX7e89OWg7vk8JcHfbnGW0If5H2q232EBwiEAAIhwKR7WhkGbzHA57gkbTm4S+d/X6L5GXIg/KJmAhAIASZRnqPt6KgX9fEx85W9fIWv083ztDL4na+5GVIgTBWBEACBEGDi7Bh1YtSh83iMX0VtSFsO9HJWKu4BBIEQAIEQoIVuGfX5qAc2/LsrU9G97pNRX0nuvaL98o8Ved7Jm8yxfN/yPMSPGAACIcBEuFnUSQ3DYJ7n761R70+meGC0XB41HbXXHMu3j9o7Fd2cARiSm2gCgAWxTdTHUvdBNma6LGp11J5RbxIGGVG6jQIIhACEV0c9tua668sT5bWp6CoKAiEAAiHAiPqrqFfWWC9P/P66VAw2c55mQyAEYNDcQwgwWDtHvS9V/wCXB9Z4VtR/aDLGyGkCIUC7uUIIMFj5it9dKta5PuqpwiBj6OxUDC4zlz2ibq6ZAARCgHG0T9QLa6yXJ6c/UXMxhvK0E2d0Wb4oan/NBCAQAoyj16Tqrvm5O+mxmoox5j5CAIEQYOLcI2p5xTpnRb1YUzHhgfBATQQgEAKMm9xVdFGX5XlE0edEXaGpmPBAeJAmAhAIAcbJLaL+tmKdfM/g/2gqBEJdRgEEQoDx8oRUTDcxlzzQxj9pJibERVEXdll+y6jdNROAQAgwLh5fsfxLUT/VTEwQVwkBBEKAibBt1LKKdYwqikAoEAIIhABjaGnq3l30T1H/pZkQCAVCgDa4qSYA6Kv7VSxfH3W1Zlpwd07FVCB7pOJ+tVz53rWbpWIQoG2irikD+8VR50edEzUd9fOoX2hCgRBAIASgyj4Vy7+hiQYuT/dxz1R03X1I1AOjbj3Px8yDonw76ptRX4n6USqmDqGeM6OuL4P3XMdN7m59raYCEAgBRtmSiuXf10QDc9+oI6KeGHWnPj/2bqkYPfYJ5f//VdRJUR+J+q6mr3Rl1NlRd59j+bZlKDxdUwEsLPcQAixsIJzWRH2V79d8dtSGMpi9eABhcDZ3Kp/rO+VzPysV3U+Zm26jAAIhwNjr1jUxzz/4G03UtyD4qqhfRr0n6t5D3Jb83O9NxX2Hr0zdBxUSCAVCAIEQYIzdssuySzXPvG0X9bKoc6NeF7W4ZT8GvD4Vg9G8pNxWBEIAgRDA5+qNDJgxP3mAmFOj3hR1mxZv565R/xb1w1QMaEPhNIEQQCAEGHfdppRwj1lv8rQQ66K+lqpHcW2TPM3F16PeEXVzb+ON9892u0remQoEgAVklFGA/vpjKq4QzWanqO2TeQibODDqE1F3m+fjXBJ1SioGgMnBJN97+Ouoy6MuS8XV253L8JlHFN0zFQME5VB3n/K/9SL/8PqCqEdGPa18/kmVp+n4cdQDuqyTrxKamgVAIAQYWRd0CYSpDBk/0Uy1PDPqnVE79vC3ec67fHXuP8v6aaqeN3Bj+e8ZUV/ealmeLuGQqMdFPTzNPZ/eXO5WBp3nRX1wgt/T0wVCgHbRZRSgv86pEQyo/m56c9QHegiDuf3zSJ+7l8HtzWUAn+8k8j9LRdfPHArvEPXyqF80fIwdyteUB55ZNMGBsJt72v0BBEKAcQ6EBs7oLvdcOT7qyB6CxlOi9o56Yxrs9B6/i1qTim6lT0rF4DFN5MD67tT8KuMkBELHB4BACDDSznTC27Ntoz6einvt6srB7+mpuLJ0QirmelwouVvqSVFLy204v8Hfroj62ASGwqpAuH+a3KunAAIhwASc8AqEs8vB6ENRT6y5fg5+b03FvX0fXeAguLVN5TbkAWje3mBbnhz1ngkLQBenYjCfueTRWPdwOAAIhACjKl8hvL7L8tylcXvN9BdykHpKzXVzoFgW9dJUjBDaFnlbXpyK+RJ/XfNv/j4VXVwniR9NAARCgLF1ZdTZXZbne+T21UxbyNMyPK/muidHHRT13y1+Pd+KulfUf9Vcf3UqupAKhAIhgEAI4IR3ojw46i01180DsfxN1B9G4HVdFHVYuc11HJOKexEdH44PAIEQwAnvRLh1Ku69267GunlUz3wV8foRen3Xl9v82hrr5m7En4jaxfHh+AAQCAGc8E6Cd0XdqcZ6a1Mx79+oenXUUTXW2yMV91KOuzwv5HVdlrvPFkAgBBAIx1yev+/wGuvlETwvTaM/PcNroo6tsV6evuKwMX/vr446q8ty99kCCIQAI2066vIuy++YJqNr4FxuEfW2muvmKRleH/WVqN1H/HXnwXM+W2O9HBx3HvN9wI8mAAIhwNjK89Cd4YR3Ti8vQ3ETD406NdW7qthW+Wrn35U/GHSTg+9qgRAAgRDACe+4yfcM/kOPf3urqI9HvT+N7hW0S1IxIf01Feu9JGpXxwcAAiHAaDrVCe+sXhG1wzwfI0/m/sOo+4xoG+Rtf0PFOjnwvnyM94PTHB8AAiHAOHPC+5duH/WsPj3WXlHfTEXXylH8LsvTaPy0Yp3nlm02js6L+mOX5ZN+ny2AQAgw4qq6xO0/gZ/Bz0/Vcw5+tcHjbRv1L1HrU73pK9okdxn9x4p1dijbbFKPEVcJAQRCgJF1cdSvuyy/edSSCWqPHN6eXbHOd6IeHvXUVNxrV1f+m9xF94kj1iZfrBGAc5vdVCAEQCAEcMI7yh4VtVvFOq8p/80DxxwU9Y0Gj5+7F54Y9Z6onUaoXV5XsTy32WETenzc00cIgEAIIBCOhyMqlp8Z9aUZ//+XUf8r6p+jrmvwPPmK2oaoe49Iu+T5FX9csc6THR8ACIQATnhH1c1ScYWwm7enYp6+ma5PxRW0PAfhdIPnu3vUt6NeNiLfc++uWJ7bbtsJPD72c54CIBACCISj7xFlKJzLVVEf67I8h7t7RR3f4Dnz4DVvSsVVxzu0vH0+FHVll+W5O+yDx3C/yKOM/rLL8tz1d0kCQCAEGFE/Sd27O+5VEZTGxV9XLP98qh5E5k9Rfxv1jPJ/17UsFQPOPK7F7ZNfz5cr1nnMmO4bfjQBEAgBxtbVUWd1Wb5N1D0moB0eVrH8Mw0e68OpGGzkWw3+5jZRn4o6NmrHlrbRpyuWP0QgBEAgBHDCO2p2TsW9YN18seFjnluGzNem4j7DuvJE799PxQimbfP5iuU5BN/M8QGAQAjghHeUHJiKK6Fz+XnUb3t43NwV99VlMPxFg7/LV2S/m4pJ4Re1qJ1+k7rfT5fnItzf8QGAQAjghHeU3K1i+Xfm+fjfTMUVv481+Jvto94S9YVUPTfiQvpexfL9xnD/+GnUtV2WT8p9tgACIYBAOJb2qlh+Rh+eI49W+bSoZ0Zd2uDv8mA3p0U9uiVt9cOK5XuP4f5xbRkK5zIp99kCCIQAY+q8ipCSr1Dddoxff9W0AWf28bn+PRXTU3yvwd/kts+D2uR5EHcYcltVzbV45zHdR3QbBRAIAcZWnmz9xxN8wls1B+Bv+vx850Q9KOqNqf6AM/lewhemYsCZYb4X582zLQVCAARCgBY6dYJPeHeqWP7rATxnHnDmlVF/FXV+g7/Lg7bkq4svSsMZcObCebalQAiAQAjQQqcJhHO6coDP/bVUDDjziQZ/k7uNHhP1uahdF7itLq9YvqPjAwCBEGD0TPIVkJ0rll824OffGLU86tkNn+uwMqgcuoBtVRWObzGm+0i+intxl+Xjfp8tgEAIIBB2nauP+Xtf1NKoUxr8ze1SMWH8v6ViqopBq+qmev2EHyMACIQAIylPi9Bt0vE8z9peY/ra/1SxfOcF3Jazoh4YtTbqhgYh7SWpuLdw0NMfVP0ocPkYHyNVgfBAHyMAAiHAOJ/wjusVkKpukIsXeHvyvHerox6Zmg1okwNJvrr4vDS4AWduXeOHhUk9Pg7yEQIgEAIIhKOn6grhHYe0XV8uQ8YnG/xNvpL7rqhPpcHc07ZbxfLLHR8ACIQATnhHSdVVuLsMcdv+EPXEqJVRVzT4u8emYiqRQ/q8PbtXLP/lGB8fea7OTV2W5+667rMFEAgBBMIR84uK5XdrwTauS8WAMz9s8De3j/pS1JtS/wacqbpHcXqMj49Lo87rsnyc77MFEAgBJsBPU3H/2lyWpPGcePysiuVLW/T+PCDq6NT9StVM+V7Cl0V9K2qfPmzD/hMcCDPdRgEEQoCxdW0ZOrp9Hu83gSf592vRtl5dBry/jrqgwd/dO2pD1Ip5Pv+DKpb/TCAEQCAEcMI7Ss6MuqrL8l1T+7oCnpyKAWc+0+Bvdow6LuqkVD1a6Gz2Td0HqsmjtZ7h+ABAIARwwjtK8pXR71es85gWbvdFUY+Pen6qnjpjpiekYsCZRzR8vsMqluc2vM7xAYBACOCEd9T89wgGwizfS3hs1H2iTmvwd3kqjXyVcU3UtjX/5rEVy786AcdHvt/06i7Lx/U+WwCBEEAgHOtA+NmK5Q9NRdfRtspdNfO9jm9L9Qecyd+vq1Ix4MzeFevuEfWQinVOnoDjI18B/UlFm+6XABAIAUZUnkfuj12W53vIdhvD150HXOk2H2GeX+7vWv4a8n2Q/5CKrp2/bfB3B5ev/1ld1vnfqRixdC6/K4PlJNBtFEAgBBhrp07gCW++qlY1QMvKEflO+mLUgVFfaPA3O0e9N2oqavFWy7YrX3s3J0bdIBAKhAACIcDoq7oXbVxPeD9asTyPNLp8RF5LvmL3qKiXpO4jqG7tyVE/inrYjP/2jFRMct/Nhyfo+BAIAQRCACe8Y+gbqXqS+lelovvoKMhXPY+Jum9qNh3E7lFfjnpDKgZI+eeK9fNjf3OCjo9J/cEEQCAEEAhvdM8xfd05QL2jYp39U/vvJZzt/cz3Cb4z1R9wJofeV0T9POouFeseN2HHx29SMeXHXMb1PlsAgRBgQvy4IjjkCcpvOqav/QNRF1es8y9Rtxqx15W7jb4wFVNHXNTg76q6iv4+6n0TeIzoNgogEAKMrUujzuuyfPtUPU3BqLosam3FOreLevOIvr7PpWLAmf/q0+O9NeoKgfAvHOhjBEAgBBjnE95xvgKSu41eWLHO/4l63Ii+vvzaDo06MnWfZL1KHrjm7Y6PWR3kIwRAIAQQCEdTvuL1+op18px8/x6154i+xtwl+C1R90/dJ1rvJg82c6njY+KODwCBEMAJ79if8OaBUqpGk7xl1Ceidhzh15mnmMgDzry74d/9IBXzFk6qPLJqt3kXx/k+WwCBEEAgHPtAeF3Uc6Our1gvj7j66VRM3j6q8hXR50U9NdUbhTS3zcoabTPOLo+a7rJ8nO+zBRAIASZAno+v2/1le0TdfMzb4Nup6FZZZVkqRifdZoRfaw60R6SiK2yVNVGnOER0GwUQCAHGV74K1O3eshwc9p+AdsgT0f+wxnpPj5qK2mEEX+PNok6MekyNdb8b9TqHh0AIIBACOOGdhBPea6KWR22sse4Tor6YRmuOwttErY96dI118/yFTy3bBMcHgEAI4IR3IpxTBqE698w9LBUDrtxzBF5XHkzm+1EPrBmMcxuc57BwfAAIhABOeCfthDdP5P6imuveNRX3Hz4/1bsnb6HlbXpZ1DdTcS9olTzQTJ538SsOiS2cHXVll+W5bW+umQAEQgCBcDwcG/XKmuvmewnfGfW1qLu36DXk+z6/GvWmVH9k1FVRH3Y4/IV8xfjMiuC9v2YCEAgBRtWvo37fZfkuUXecsDZ5Y9SrG6z/kFTM9ZdHK73NELf7tlFHp2KAnIc2+Lt/KsMjs/OjCYBACDDWqiZnn8QT3temosvlpprr56uF/xh1btQbFjhE374MdPm5X5rqT5a+qdzm1zsE5hUI99VEAAIhwDif8E7qFZB8tS3P23dVg7/ZOeoVqRiYJU9RcWgazIT2OfQdFvXJqF+U4XWnBn+fX1MeQObf7P6VflyxfIkmAujPFxsA7QyEB01w23w0FSOQnpSaXfXL32tPLuuSqM+lYrqKfL/hr3rYjnyv2l6pGC30b8qgecseX9O55Xb9wK5fy9kCIYBACDDJgfDACW+f70XdK+qDqbgq11Ses/AZZWUXpGKgkhw0p6MujLos6o+p6HqaJ5HPI1feIeouqRjRdGnqz9yHn4r6+zKkUs8vK5bvqokABEKAUXZG1A1p7u77+0RtG3XtBLdRnrD90WWYenPU4nk81u3L+qsF3P6NUf8v6n2p/n2RFK4rA/vOcyzfURMBzJ97CAGG5/JUXKmay7ZlKJx0OUi9P+oeUSeM0HZ/PBUDn7xXGOzZ9V2W7ax5AARCgFFnYJn6chfPp0Q9PGpDi7fz66mYfiIPHvNbb9u8bNNl2WWaB0AgBBAIJ89Xo+4T9dgyfLXFN6MeWYbBr3ub5i3f1tLtKuAVmghAIAQQCCdT7oL52TJ85YFn3jukgHBp1Luj7hn14KiTvTV9s3vF8t9pIgCBEEAg5EdRz4naLRXdNE8og9qg5K6KeR7CPHppHpH0eVGnehv6bu+K5dOaCGD+jDIKMFx5rrUrUzHlwWzyVZI8790fNVWlHAI/XlaeRuL+UQ+KekDU/aJu0+Pj5nsXfxj1nVR0Bc1dQ6/R3AN334rl52giAIEQYNTlURTz3HhLu6yTrxJ+Q1M1clUq7jX86oz/dtuou5chO19NzFNY5KkLOvep5St/eeTXP6RiDrxflPUHzTkUD6tY/iNNBCAQAoyD0wXCBXFRWbRfDusPqVjnW5oJYP7cQwjQjkCYKgIhTJInpWIezrlckIru1gAIhAACIYyZ51cs/4wmAhAIAcbFaQIh/NkjUjGVSDcnaSYAgRBgXPw2FSNZziWPMrq7ZmICLIp6Y8U6v476iqYCEAgBxoluo5DSM1MxRUg37466TlMBCIQAkxQI76mJGHN3iHpzxTp5zs73aSoAgRBg0gKhK4SMszwN1seidqlY752pGGEUAIEQQCCEMXFMqp538E9RazUVgEAIMI7OjLq+y/K9o7bXTIyhNVHPq7HeK6J+r7kABEKAcZTvjeo20XbuUrevZmLMzkHeHrWqxrrfijpWkwEIhADjTLdRJsWtoz4b9cIa6/4xFaOP3qDZAARCAIEQRtvfRP0g6rAa626KelbUzzUbgEAIIBDC6Non6hNRn4/avebfvD7qRE0HMDg31QQAAiEMyKKoB0W9IOrJDc878j2D/6wJAQRCgEkxHXV51E5zLL9jKuZpu1hT0WK7Rd0/6hFRj0v1rwbOtC7qRZoSQCAEmCR50Iwzou7bZZ18lfBrmooW2CHqHuU+uX/UgeW/d5jn4/5L1CtTcf8gAAIhwEQ5XSCkZfJ4A0tmBL4Dytoraps+Ps8VUc+N+pAmBxAIASY5EKaKQAiDcrsZgW+/qINScRVwxwXY758RdZq3AEAgBJhkVSfEAiH9sFMZ+DpX/TpdPm+7wNtxTdQbotaU/xsAgRBgop1asTyfuOeRG91fRd3v+b3KsNe51y//e9c03Kmn8v2yH4l6dSoGUwJAIAQgFSOI/joVI4rO5uZRe0Sdq6nYyp3S5qt+nfCXu3tu36JtvLwMgsdE/dhbBiAQAvCXTu8SCLN7CYQT7ZZpczfPA2bU4pZu77VR/x31yaiPRV3iLQQQCAHoHggP7bI8T/R9kmYae9tG7Tsj+HVC4B4t3+6Lon4U9b2ob0d9I+qP3k4AgRCAen5Ysfyhmmjs7DEj+OUun7nr5z5lKGyrPE3EmakYCCl3/zy9rN96OwEEQgB69+2K5Uujdo/6paYaObukLSdy70zvcIsWb/P1UWfPCHw/LkNgHgzmBm8pgEAIQH+dV56A7zXH8jzK6FOj/lVTtdYOqRjQZf+twt8dWr7dv5kR+M4o/81XAa/ylgIIhAAsnDwAx//tsvwFUW9OrtAMW566IU/hkCdw3y9tHuDlblHbtHi7L01bdvPM4S9PeXKxtxRAIARg+E6qCIS5y2i+SvgRTbVgdk1b3uOX/81XAXdq8TbnET7PKsPfqeW/uc5L5rIEQCAEaK3vpqKr3j26rPO6qBOjrtZcfbVT2e458M2c2mHXlm/3L1JxpS9f8esM9PLTqGu8pQAIhACjJV+9OTbq7V3WWRK1Ouo1mqvn78C9ZgS+zr1+uQvoTVq83ZekLe/x63T9NLUDAAIhwBj5YBn2dumyziuiPp2Ked+Y2x1nBL7OQC/5KuAOLd7mfGXvzLR5ZM/Ov+d7OwEQCAHG32VRa1L30US3S0W30YOjNmqyG6dv6Nzf17nqd0BFqB62fDX43LTllA7533zv33XeUgAEQoDJ9Y6oF0Xducs6uevoJ6IeHXXlhLRLnrB9nzL8HZQ2X/Xbo+Xb/fsZgW/m9A6X2dUBEAgB2FoOeC9Jxaij3TwiairqyWn85ozbY0bg69zvt08ZCtv8vnUGeJk5vcOFdmkABEIAmshzEp4QdXjFeo+K+lLU49Nodh9dnLYc2bPz7y1avM3XR02n4krfzC6f0+UyABAIAZi3PBH9/VMx/2A3D43aUIbHU1r6WrZPxYAuM0f2zF0/79Ty9+CCtOXVvlx50Jcr7Z4ACIQADFK+9+xJUV9P1SNj5mkTvhm1NuqNaXhdSG9SbsvM4Jf/914t//65LG05qmdnUvc/2A0BEAgBGJZ8xe/ZUf8etU3Funn00X+KOiIVU1ccH3XDALdt1xnBL1ce6CVfBdypxe2ZR/A8K22eyL1zz18e8XOT3Q0AgRCAtvlwKu6pe1fN9ZeUATKHwnVRH4r61Tyef8e0eVqH/dLmQV5u1/J2y3P3/Xir8Je7e15jlwJAIARglBxb/vv2VH2lsGOPVHQffUPU96O+HPWdMhj9MuraWYJfDpP7zAh/B5b/7SYtbptL0pZTOnRC4CV2GwAQCAHGKRRelIquoNs3+LtFUfctqyN3nbw06k/l90Lu5nmrlr/+fGXvJ2nLQV5+XIZbAEAgBBh7eTL681IxJcVd5/ldsListtlUvsaZ3T3z/873/l1rFwAAgRBgkuWBZu6dinsKnzbir+UPafP9fZ15/fL/vtTbDAACIQCzy/fHPT3qP8pgeNeWb+9VafOInjPD3wXeSgAQCAHozRdTMQjMc6NeHrXbkLcnT3MxnYo5/DoDveTgd3bU9d4uABAIAeivPNjKMVHvTcVVwxdE3XMBnve3afPgLp3K0zpc4S0BAIEQgIV1RRkKc+V7DJ8U9fhUTBY/H5eVQa8zuEuufAXw95ocAARCANrnB2W9MhXdSB8QdXDU3VIxr+Dto26Wiqkm8sidl6diCoo8hcO5qRjRs3PPX+4CukmTAoBACMDouTDqk2UBABNu0aZNfugFAACYRDfRBAAAAAIhAAAAAiEAAAACIQAAAAIhAAAAAiEAAAACIQAAAAIhAAAAAiEAAAACIQAAAAIhAAAAAiEAAAACIQAAAAIhAAAAAiEAAAACIQAAAAIhAAAAAiEAAAACIQAAAAIhAAAAAiEAAAACIQAAAAIhAAAAAiEAAIBACAAAgEAIAACAQAgAAIBACAAAgEAIAACAQAgAAIBACAAAgEAIAACAQAgAAIBACAAAgEAIAACAQAgAAIBACAAAgEAIAACAQAgAAIBACAAAgEAIAACAQAgAAIBACAAAgEAIAACAQAgAAIBACAAAgEAIAAAgEAIAACAQAgAAMDluqgkYZYsWLdIIAMzLq9989JL4Z3nU0qiNUdNR617zsiM3ah1ms2nTJo3A+JxP26ERCAGY4DC4Kv5ZM8uiHAZXRiic0koIhAiEIBACMDlhcKZDIhSur3icFfHP4orH2VD1OC1oj86V0ipT8Vqmh7B9rWln58+ME11GAYBJDINLaoTB7LioPSvWySFqWcU6q6PWt7xZ6rbJhlR0q11o49LOIBBCU0cd/ZZZfxWML/TZVu/5l8sGv45ujOdYN6EnUNoHej+GVjX8k9ZfVRphy2uutyTet2XeB0AghOF/cS+ruW4OLSt7fJ66v47mE4NJDDzaB3oPg8trHj9bBMKog7VeKz77AMaSaScYRyvyr7maAWiZXj6XlpZX5hkuo40CAiGMmFWaAGiZ5T3+3QpNNxBNbi3YoLkAgRBGy7KyexbA0JWfR4t7/HOfZQNQTidRJxQOZURNAIEQ5m+NJgBaYj7d2POgJks14UAcnrp3B81XBldqJkAghNG0pIcR/QAGYfmQ/55ZvOZlR+bAd0iafZqCPDBWnoPQ/YOAQAgjbFWEwsWaARiWmt1Fq0KHQDjAUBiVQ+GeZTjMtUv8t5XCIDAJTDvBuMsnYfkq4WpNAQxJne6iGyrWu7HbaHlFi8EEw3yfoHsFgYnjCiGTYJVh24Ehqrq6tz7N3mWx6eMAQGOuEDIpjktFN6DWKkPrzOA6bWS78VUOEjJbN8KNrgKN1ftcp7vohlRvWoP8WKsdI5N7jGgTQCCE3uVpKJbFF+b6tmxQeaKYv9yXlf/Otk7nZDFv94ZymPRxOrGpMxLs6q1PdOJvV8xot5khemPafLVlqur+n/L+0uVzPNZ0p+3jcdbN87Uu2+q9Xlyxfuf515fbMNXve5nK9p+5D24dUNaXr319P96zHo+N2bYtlds2XW5f24+JWt1FczuX73s3jbuNlgNrLRvUe1Yei3WuXK7s9gPXsI6ReJw1c33+zjA138+AcfncqHHcLitr61450zM+V6bafm9mnc+go45+y41tfdSRLx2b72UEQpgE+Yv/4BZ80eQTqFWzfGHOpfOllP82fwGtHcbJyQAsrnmiunirL+njupwYdQJerjWx/sq5AkN5oryqy2N1rtguL9dd3SR8lGFzRVm9dFlekjZPSJ5fy9r4d918T6TKk8yqkNDZ53J36/UzTuYbv2cDaq/ONqyIv8vt0Ze2GcCxvjjVmFR+xn61vkb7Lk/NJklfXzPEN33cjhU1AtWG2cJgS46RpTXafP0Q9plWfW7U+HHpuIr94M+fpwu1XQv1GRTB8M+fQREODULESHIPIeOk6mRmaRnGhvVlk3/dP6X84uz1nsb8d8flx5m0+yLj9eZ2O6FB2MjrnbD1e56/9KNOLk+SFzdo9xPKqwlNTjTXzOO93vq15Mc6ZT7z0ZXbf3JqNifesvk+b82QekqP7dVpm3PKHwzapM72rG8YPBq9xvKq33S/H7fzmVYjDGZTo3KMtMBItUn5+XpKzf2gte9Vvz6DIhy6zxeBEIaszknPmmFMQ1F+6TX90qw6aThlUiarLq/Q9Rrmj9sqKDQNRDOtGvLclvlE5eRe3vcyUPe67YvLdlsygPd2RZ8ee9YfAIaszn7WNBD2Mkn9ugE97vI+Pv/Qj5ExNpA2KY+14+a5XacM+5jt92dQhMIVdjkEQhieOgMz1OrCNYAweHLqoRtdnZP0CTjxqXvfWtcfAmYEy/m215ohX51d3PQkrAyDK/rwvGv6fGysmucJ5Vw/AAz9hGzG/am1A2F5Na9Ol7OmVyHqdnVu+kNJnfWHcb/Y4gHsV6Ou322ytI+Pd9ywru4P6jNIKEQghOHJJyd1folesGkoyucZRBic+SV/wjCuei6gflyRWzLjnsG2bNO8Tsbqhp5yvRV93N/6dWys6HfAbFForxvaZhsZchDdRqf7/bjlZ06tQNj2Y2SC9LNN+v0ZeNxCH7OD/gyKUGi6KwRCGJJ88lH1a/TiBTyhb3LPW89hJ433r+H9ar81fXysFS0I4ZX7cLmNa9r2hpYnfmsGvM8M+5joNSwNqttonWC2tMF+XTfwTrX5GJlAq/p4jI3sMTshn0EgEDKRFpddk9bWPKFfNsiNadg9Mf+Cn+cXO6Ssw1NxtbNuV6vlg349LbKhfI/XpXr3jVa1+7ry8ZqOsLh8Hs85Vb7fM6vpNtQJBb2E4M7UHYPs5ndcg+1aN+O4yLWy5vu+bFhXCRt0F93QYyDsZf+b6vPjLqv53rX9GBkVo9Im62dU4x9RFvB7bEE+g1wlZFSYdoJxsnTGh/eqGh/2q9KAhhMvTwjr/hKbt3f1LPfZTMXjrEvVw3kP/PW0KAiunGVOwl7uj9tYtvm6rR6rySAJTb7oO8FzqttcbOU25BOiuleWl811MtgglMwMDKtnbl8ZqJanPv6SXr6+ZTXfo0NmmxsvHiNv68k1josVaTgTuddt9784XnP7l9PLLKnxHLVfW/58KT9PVtTYp9b1KfBOtfkYGZEQOAptMufULzO6ZdYNXwP/HpuQzyBoxBVCxk6Dq4TLBngj+/KaX4B5fq6Vcw26UH4Rraz5nMvGeCqKDXN9Mef2a3gC0fmSXzfLY61r8OVdJ6RPlyF2z6i1VSd15Tas79MJRN19MJXbePjW25f/f97u1N/5O5c3eI82dDnGD+9jMOu3upPRT88jSPVypadf9xHWfX0bWn6MtDkIjkqb5Pf44HI7N87xmXpwgwC6EN9jk/AZBAIhpPrdLQd1D0HdK1aVX+DlF9Lamo83rl8+qytGKmzSNW1txYlqv4bI75wo9fJ4/RgVsm7Xq6mqbSzbq18nm8v78B51BkqpaqclQxioovHoonPsO30/3sv7+aZrvIbl89jvmuzDwz5G2miU2qQTmqZrHKsrU4NbIFoQCCs/g4468qW1PoN0G0UghCFpcJVwyVajrs37vqnyhLDW1aPyV91JPvmpdYJU1U4NB66YqrHvrO/HPtjrcPt9Gqa/7r5Q98eGdfM9PsquWlVXLTc2COV1gtNCn4z13F20h/25lxPnqT7sO8tr7i9tP0Za+d01Qm2yuu5zNvxhc2D3OE7IZxAIhNDDCeyqrb60FupEvHaIKbdruo/PPUrqhrM67/V0ne5XaXTvOeqc9CxJ9bssb6i5D25M859CoM6J3voGJ7Yb+vSc/VTr3qQaPwYNqtvovAJhefWwat+aGtfAxhafpU2vYq7r4+eEzyDoI4PKMLbKQRRyN7eqQUJuvErYYxedWR+vj18kW3wB13nsHAZqhp5R0eSLeVmNNuznc/YjuA3i1+NB7oMDf78bjDTYqhOtPg+2sr7mYy1v8j7mHwBiOzdUtN2NQXOOHwuW9un1DfsYGVktaZPGvSjK7+T1NT6nh/3aan0GHXX0W4Q9BEIYkVC4ruwSWvWhna8SLnQgbBo66gSezvOPUyDc0NLH6uUkbnm5Ly4d8ElP3cFkphe4/ersvytS81Fj22J5H9uxyfQTTe/vnKrxmTjXSJRVr7HnuQcX+BgZpfDXxjbp9TumTiC88ceVAV1lHvfPIOiJLqOM25fnbB/2dU6Wtr6XcOCBsMH9g70GSFrQhvmELioPB39OKgYxWr4AJ3WuqAxH37qLl1f5a92f1EO30To/fi2fZV+uE0imRuQYaX0QbHmbDPrHNVfeYAG5QsjYy8Gr5vxby1P/rhJCPqlblQY3ki3teq+bzPt4cazfz6dv2m10YzmPWrftXTrLVZq+DCbjGNEmQLu4QsikyKObVV0dWlZeYdyguejDSd0aJ3WtsFBXhYc55Usvz93LnISV9+g2GZjLMaJNuu1LPoNAIIS+Krtf1RnyenlauAFFdIkZ35O6vB+tGuImDOpHjcXz/PthnBgt1InlMEf4bdxttBxEq+r9WDpjn16SqrvxrRuhY8TnxvwM9PtrgAOjjfNnEPRMl1EmSafbaLf7MFb04WS67uAvTU+u634B+/IZvia/8G8s95kNW52sLMRVgryfrh3APtjt2FjoK2kDPwFs2F10UBp1Gy1Npe5d6fNjrmwQeKfG8BjxuTHHjxDz+MwZprH8DAKBEGoq75vJJ79V01As1FWQfHLdZGCZuoPVCIRDVP7KX/dkKQ94tG620fTKrmPzOempdXLWcDS/5QtwbOR1Du/jcb8QXcCXt2DX62W00ap7qxfPmH6i6seAqbqfPS05RnxuzM+yHl7j4lRzHsAhh7O+fgYddeRL3YaCQAgtC4Xryi/eZfMNXn04Ga99taVmd61Bf5HS3/d1beyPawe0n+cfP6Zr7ss5EKytsQ+u6sOxUWf/XFy+hlHal5e1YBu6zR04Z1iusZ907qte1of3tjXHiM+NvuxvTefvXZ7q/eA6yADVt8+gTZs2+bZjbLiHkEm0esCPX/fLbHkZ9Op+kfbry452nNgNekTbuvvCqqr7z8rl8763qbyCVOcq0nHl1YTWa0l30aafE032wyU1JkLf2DAYtOUY8bkxP6vqHqflenWvXg4sEI7jZxAIhNDbF8KGQX6plt146t5LU3mSXX4p1Z0jUSAcnf1wust73o/5xuruC3n/OnmOOTxTOT/nyWn+XambnNAuKbepp+fMf1f2BGhrCGvTtlR9Vi2rEVamRvQY8bkxP/n5jqtzPDb4DMk/LkwNeLsH/hl01NFvWRy1PMGI0GWUSbU61e++0uvJeJ0vgxXxhbOh4tf1NaleV731C3S/FH2QA0uXE595n0jkx27QbbQTCqfLfXe6DAFLU/8nw55K9a4U5Oc+JbZpZd3uozN+PMk/tCxUt7q63UVXNryKtvWJ/jl1TmJ76DY6HX+zvsvr6Ovoom06Rnxu9OdHiNimU+Lfw2cLq+UPTWtS/SugUwuwzQP7DMpBcAifQSAQQo8ny50BZtYM6PHXNbjnqtM1ZYtBAsqTwDUNvuR9+bRD3VFmc3er9VsPDFGeQPVr6Pn8w8cJDdZfkupfje712Jguj71VNbfn5DKwrJ/tR4+yO2unBvkjz1wBdODducs2qxvuex1ttNs+2+29mu7hh6g2HSM+N+YvH3vnzDhOU3kc1rm6vODfY/3+DIoQOLTPIBAIYf5fCmvL7nCD6mbT5GT8xsmI89XCVIxwtqThdq0fsUE4xlndUV47J1Ez54Nbmvr4K395lXAqte9qytoyeNY9cVrWOVmO19Om11G3XTf0YfTfqZonsL2MNpof+7get2vdKB8jPjf6alma3wBLaxdwlOx5fwZFEPRtx9hwDyGTbmADzJTdepp2f1lafuk0CYP5pGClt7I1plL9qUcWlyf5a1Kzq8FN5H2jX12JN/bp2OjrsO5DPgGuu0/MV90ffHqZpH5j6r3b59QYHCM+N4ZvY1rAXi5j9BkEAiH0KbQN8spaP0/G53K4uQdbtU8t6IlNze05pA/7YV9fV3lFe2R/yFio7qJbtdcg54vsZRvX9/LZ07ZjxOdGT/q9rYc3mA/VZxAIhDCQ0Nb2k/E5t11X0VZa14f3fP0A9sNerwINZD8uB1kZ1ROyuqFruo+DPU31edtmvhf5sacHtD2tP0Z8bvT0PP0aTGho32Mj/hkEAiH08QshnwStHeDjd06m+/mFd+Nj9jpqIQPfpzrdeHv9xXttv0/s8jZFrexhX8z72J6DGsG23IcP7iGMDFvd7qL9fB/rvgeNu432EPA2pnkEwjYeIz43Gm/vyj6EwpXD/h4b4c8gEAihz9amPt0f1eVk/JDyy36+XzqdE3RXBtt9cpdP3vfs4QRtdfztIO9tXV/ui3nbVpcn9TO7I24o///qcj9b2UNXruke2urg8jn7cRyuH+SJ8UJ3F+0xsA1ikvottmW+Xfzaeoz43GgcClf3eIwe3JYfNUftMwj6zSijkAY/DcWM58lffuvK0U2XNThp21CeDE65X3C09qv455BySPjlae4hyafL93fdQr2/PV4ZX9rgsXtpq7w9a2ccH8tSzcmsy5OvDQt0jDQJW33t+luORLy05jaubrpPNHj8qXE/Rnxu1N7eteVoxitS9cidne1d39J278tn0FFHvtT3NCNl0aZNm7QCo7sDL1o08q+h/NLPXzhL5giCGxb6ZnsW5D3vnISsH/BzLe1Xd89yAuqqsJCvhu/Sx+1f3O05XSl3jGiT1m3n0vI7bemM77GNg+p2vgCvp+tnUIQ/+ycCIQiE0OqTmTw8fT6RXDmfqwjxOPkqRZ15NfMVOsO5A2PN+TPjxD2EAOMvB8I8mfVxUUua/nF5ZaLuxOUbNDcAjA73EAJMjhvv8SnvE8v38mzo1vWsvCq4rPy7uqY0MwAIhAC019Kycujr/Lf1Wy1f3MPjrjPoEQAIhACMnmV9eIy1mhEARot7CAHoh9WuDgKAQAjA5MldRV0dBACBEIAJDIMrNQMACIQATI6NqegmKgwCwAgzqAzAeMvTQOS5B/MUEov79Jjrota6ZxAARt+iTZs2aQVGdwdetEgjQE0z5hVcVobEJqbLcGlqCWDiOX9GIASBEEY9HOarhX+ej7DU+W+5O+iGGUFwgxAIIBAiEAIAADBGDCoDAAAgEAIAACAQAgAAIBACAAAgEAIAACAQAgAAIBACAAAgEAIAACAQAgAAIBACAAAgEAIAACAQAgAAIBACAAAgEAIAACAQAgAAIBACAAAgEAIAACAQAgAAIBACAAAgEAIAACAQAgAAIBACAAAgEAIAACAQAgAACIQAAAAIhAAAAAiEAAAACIQAAAAIhAAAAAiEAAAACIQAAAAIhAAAAAiEAAAACIQAAAAIhAAAAAiEAAAACIQAAAAIhAAAAAiEAAAACIQAAAAIhAAAAAiEAAAACIQAAAAIhAAAAAiEAAAACIQAAAAIhAAAAAKhJgAAABAIAQAAEAgBAAAQCAEAABAIAQAAEAgBAAAQCAEAABAIAQAAEAgBAAAQCAEAABAIAQAAEAgBAAAQCAEAABAIAQAAEAgBAAAQCAEAABAIAQAAEAgBAAAQCAEAABAIAQAAEAgBAAAQCAEAABAIAQAAEAgBAAAEQgAAAARCAAAABEIAAAAEQgAAAARCAAAABEIAAAAEQgAAAARCAAAABEIAAAAEQgAAAARCAAAABEIAAAAEQgAAAARCAAAABEIAAAAEQgAAAARCAAAABEIAAAAEQgAAAOr7/wIMAEPme10LxyAWAAAAAElFTkSuQmCC',
      extension: extName ? extName : 'png',
    });

    sheetAirPortCard.addImage(imageId2, 'A1:A1');

    const titleCell = sheetAirPortCard.getCell('A2');
    titleCell.value = `${editedRow?.stag_name}`;
    titleCell.font = {
      name: 'Arial',
      size: 83,
      bold: true,
    };
    titleCell.alignment = {
      horizontal: 'center',
      vertical: 'middle',
    };

    const secondRow = sheetAirPortCard.getRow(2);
    secondRow.height = 120;

    //const guideNames = editedRow?.guides.map(getName);

    promise.then(() => {
      workbook.xlsx.writeBuffer().then(function (data) {
        const blob = new Blob([data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = `${editedRow?.name}-${guideNames.join('-')}-${
          editedRow?.arrival_date
        }.xlsx`;
        anchor.click();
        window.URL.revokeObjectURL(url);
      });
    });
  };

  const [anchorEl, setAnchorEl] = useState<any>({
    open: false,
    anchorEl: null,
  });

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl({
      anchorEl: event.currentTarget,
      open: true,
    });
  };

  const handleClose = () => {
    setAnchorEl({
      anchorEl: null,
      open: false,
    });
  };

  const dispatch = useContext(DispatchContext);

  useEffect(() => {
    if (viewAgent) {
      setViewAgentOption(viewAgent);
    }
  }, []);

  useEffect(() => {
    setProgress(progressPercent);
  }, [progressPercent]);

  function handleItemSelect(value: any, type: string) {
    if (type === 'ba') {
      dispatch({ type: 'SET_VIEW_AGENT', payload: value });
      setViewAgentOption(value);
    }
    if (type === 'sp') {
      setSpOption(value);
      if (onSalesPartnerSearchChange) {
        onSalesPartnerSearchChange(value);
      }
    }
    if (type === 'g') {
      setGuideOption(value);
      if (onGuideFastSearchChange) {
        onGuideFastSearchChange(value);
      }
    }
  }

  const themeQuery = useTheme();
  const isMobile = useMediaQuery(themeQuery.breakpoints.down('lg'));

  const handleClickToggle = () => {
    if (onShowReservationsChange) {
      onShowReservationsChange();
    }
  };


  async function handleStatusRefresh(groupIds:any) {
    const searchParams = new URLSearchParams({
      'groupIds': groupIds
    });

    try {
      const response: any = await api.get(`/groups/refresh-status`, searchParams);

      if (refreshTableData){
        refreshTableData();
      }

      return response;
    } catch (error) {
      throw error;
    }
  }

  const refreshStatusHandleClick = async () => {
    const groupIds = rows.flatMap((item: any) =>
      item.id !== 'SUM' ? [item.id] : []
    );
    toast.promise(handleStatusRefresh(groupIds), {
      loading: 'Refresh reservation statuses...',
      success: <b>Refresh statuses!</b>,
      error: <b>Error while refresh statuses</b>,
    });
  };


  return (
    <>
      <Stack
        direction={'column'}
        gap={0}
        sx={{
          position: 'relative',
          '& .MuiToolbar-root.MuiTablePagination-toolbar': {
            minHeight: 'auto',
          },
          '& .MuiInputBase-input.MuiOutlinedInput-input': {
            height: '16px',
          },
        }}
      >
        {schema?.name === 'Activity Reservation' && selectedGroupId && (
          <IconButton
            onClick={handleClickToggle}
            aria-label="delete"
            sx={{
              position: 'absolute',
              top: '0px',
              left: '0px',
              zIndex: '10',
              color: '#fff',
              p: '0px',
              background: '#42948c',
              boxShadow: '0px 0px 0px 2px #fff',
              '&:hover': {
                background: '#2d7e75',
              },
            }}
            size="small"
          >
            {showReservations ? (
              <ExpandLessRounded fontSize={'inherit'} />
            ) : (
              <ExpandMoreRounded fontSize={'inherit'} />
            )}
          </IconButton>
        )}

        <Stack
          direction={isMobile ? 'column' : 'row'}
          alignItems={isMobile ? 'flex-start' : 'center'}
          justifyContent={'space-between'}
          sx={{
            background: '#fff',
            borderBottomLeftRadius: '10px',
            borderBottomRightRadius: '10px',
            boxShadow: '0px 0px 10px -5px #00000091',
            p: isMobile ? '5px 10px' : '5px',
            mx: '10px',
            '& .MuiStack-root>:not(style)~:not(style)': {
              marginLeft: '0px !important',
            },
            '& .MuiButtonBase-root.MuiIconButton-root': {
              background: isMobile ? '#f3f3f3' : '',
              p: '3px'
            },
            '& .MuiAutocomplete-root .MuiInputBase-root.MuiInputBase-sizeSmall': {
              borderRadius: '50px',
              paddingRight: '5px',
              paddingTop: '4px',
              paddingBottom: '4px',
              lineHeight: '13px',
              fontSize: '11px',
            },
            '& .MuiInputLabel-root': {
              lineHeight: '13px',
              fontSize: '11px',
            },
          }}
        >
          <Stack direction="row" alignItems={'center'} gap={0}>
            <Typography variant={'h5'}>{schema.pluralName}</Typography>
            <IconButton
              size={'small'}
              aria-label="fingerprint"
              onClick={handleClick}
            >
              <MoreVertIcon fontSize={'small'} />
            </IconButton>
            <Tooltip title={'Add new'}>
              <IconButton
                size={'small'}
                onClick={() => {
                  if (setCurrentAddNewRow) {
                    const addedData: any = {
                      id: 'new',
                      group: selectedGroupId ? selectedGroupId : null,
                    };

                    if (reservationDialog) {
                      if (reservationDialog?.group) {
                        addedData.group = reservationDialog?.group;
                      }
                      if (reservationDialog?.activity_reservation) {
                        addedData.activity_reservation =
                          reservationDialog?.activity_reservation;
                      }
                    }

                    setCurrentAddNewRow(addedData);
                  }
                }}
              >
                <AddIcon fontSize={'small'} color={'primary'} />
              </IconButton>
            </Tooltip>

            <Tooltip title={'Refresh table data'}>
              <IconButton
                size={'small'}
                onClick={() => {
                  if (refreshTableData) {
                    refreshTableData();
                  }
                }}
              >
                <RefreshRoundedIcon fontSize={'small'} color={'primary'} />
              </IconButton>
            </Tooltip>

            {isMobile ? (
              <IconButton
                size={'small'}
                onClick={() => setOpenFilterModal(true)}
              >
                <FilterAltRounded />
              </IconButton>
            ) : (
              showBookingAgentFilter && (
                <Stack
                  direction="row"
                  paddingLeft={'10px'}
                  alignItems={'center'}
                  spacing={2}
                  gap={'2px'}
                >
                  <Autocomplete
                    PopperComponent={LargePopper}
                    id="main-menu-sales-partner-filter"
                    onOpen={() => fetchSalesPartnerOptions()}
                    options={salesPartnerOptions}
                    value={spOption}
                    getOptionLabel={(option: any) => option?.name}
                    getOptionKey={(option: any) => option?.id}
                    sx={{
                      width: '160px',
                    }}
                    size={'small'}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Sales Partner"
                        size={'small'}
                      />
                    )}
                    isOptionEqualToValue={(option, value) => {
                      return option.id === value.id;
                    }}
                    onChange={(event, newValue) => {
                      handleItemSelect(newValue, 'sp');
                    }}
                  />

                  <Autocomplete
                    PopperComponent={LargePopper}
                    id="main-menu-booking-agent-filter"
                    onOpen={() => fetchBookingAgentOptions()}
                    options={options}
                    value={viewAgentOption}
                    getOptionLabel={(option: any) => option?.name}
                    getOptionKey={(option: any) => option?.id}
                    sx={{
                      width: '160px',
                    }}
                    size={'small'}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Booking Manager"
                        size={'small'}
                      />
                    )}
                    isOptionEqualToValue={(option, value) => {
                      return option.id === value.id;
                    }}
                    onChange={(event, newValue) => {
                      handleItemSelect(newValue, 'ba');
                    }}
                  />

                  <Autocomplete
                    id="main-menu-guide-filter"
                    PopperComponent={LargePopper}
                    onOpen={() => fetchGuideOptions()}
                    options={guideOptions}
                    value={guideOption}
                    getOptionLabel={(option: any) => option?.name}
                    getOptionKey={(option: any) => option?.id}
                    sx={{
                      width: '160px',
                    }}
                    size={'small'}
                    renderInput={(params) => (
                      <TextField {...params} label="Guide" size={'small'} />
                    )}
                    isOptionEqualToValue={(option, value) => {
                      return option.id === value.id;
                    }}
                    onChange={(event, newValue) => {
                      handleItemSelect(newValue, 'g');
                    }}
                  />
                </Stack>
              )
            )}

            {isMobile && (
              <IconButton size={'small'} onClick={() => handleOpenFilters()}>
                <TuneRounded color={'primary'} />
              </IconButton>
            )}
          </Stack>

          <Stack direction="row" alignItems={'center'} spacing={2} gap={'0px'}>
            {isView && !reservationDialog && (
              <PeriodSelector key="periodSelector" changed={() => {}} />
            )}
          </Stack>

          <Stack
            direction="row"
            alignItems={'center'}
            spacing={2}
            gap={1}
            sx={{
              marginLeft: '0px !important',
            }}
          >
            <Search>
              <SearchIconWrapper>
                <SearchRounded fontSize={'small'} />
              </SearchIconWrapper>
              <StyledInputBase
                placeholder="Search…"
                inputProps={{ 'aria-label': 'search' }}
                onChange={(e: any) => {
                  debouncedOnChangeQuickFilter(e.target.value);
                }}
              />
            </Search>

            {schema?.name === 'Service Reservations View' &&
            progressPercent !== null ? (
              <CircularProgressWithLabel size={30} value={progress} />
            ) : (
              <></>
            )}

            <TablePagination
              sx={{
                '& .MuiTablePagination-selectLabel': {
                  display: 'none',
                },
                '& .MuiTablePagination-actions': {
                  paddingLeft: '0px',
                  marginLeft: '0px',
                },
                '& .MuiInputBase-root': {
                  marginRight: '4px',
                  marginLeft: '4px',
                  fontSize: '11px',
                },
                '& .MuiToolbar-root.MuiTablePagination-toolbar': {
                  paddingLeft: '0px',
                },
                '& .MuiButtonBase-root.MuiIconButton-root': {
                  padding: '0px',
                },
                border: 'none',
                marginLeft: '0px !important',
                pointerEvents: apiRef.current?.state ? 'all' : 'none',
                opacity: apiRef.current?.state ? 1 : 0.5,
              }}
              count={
                apiRef.current?.state
                  ? gridFilteredSortedRowEntriesSelector(apiRef).length
                  : 0
              }
              page={
                apiRef.current?.state
                  ? apiRef.current.state.pagination.paginationModel.page
                  : 0
              }
              onPageChange={(event, page) => {
                onPageChange(page);
              }}
              rowsPerPage={
                apiRef.current?.state
                  ? apiRef.current.state.pagination.paginationModel.pageSize
                  : 100
              }
              onRowsPerPageChange={(event) => {
                if (onPageSizeChange) {
                  onPageSizeChange(event.target.value);
                }
              }}
              rowsPerPageOptions={[
                25,
                50,
                100,
                { label: 'All', value: rowCount },
              ]}
              size={'small'}
            />
          </Stack>
        </Stack>

        {schema?.name === 'Service Reservations View' && (
          <>
            {!reservationDialog && (
              <Stack
                direction="row"
                spacing={0.5}
                alignItems={'center'}
                justifyContent={'start'}
                sx={{
                  background: '#fff',
                  borderRadius: '10px',
                  boxShadow: '0px 0px 10px -5px #00000091',
                  p: '5px',
                  m: '0px 10px',
                  mt: '5px',
                  '& .MuiStack-root>:not(style)~:not(style)': {
                    marginLeft: '0px !important',
                  },

                  '& .MuiAutocomplete-root .MuiInputBase-root.MuiInputBase-sizeSmall': {
                    paddingRight: '5px',
                    paddingTop: '4px',
                    paddingBottom: '4px',
                    lineHeight: '13px',
                    fontSize: '11px',
                  },
                  '& .MuiInputLabel-root': {
                    lineHeight: '13px',
                    fontSize: '11px!important',
                    paddingTop: '0px!important',
                  },
                }}
              >
                <Typography
                  variant={'h6'}
                  sx={{
                    marginRight: '10px',
                  }}
                >
                  Filters:
                </Typography>
                <Box
                  sx={{
                    width: '200px',
                  }}
                >
                  <SPSelectField
                    title={'Group'}
                    onChange={(value) => {
                      debouncedOnChangeFastFilter('group', { id: value?.id });
                    }}
                    schema={group}
                    defaultValue={undefined}
                    forcedValue={undefined}
                    disabled={false}
                    isMissing={false}
                    accordingToValue={undefined}
                  />
                </Box>
                <Box
                  sx={{
                    width: '200px',
                  }}
                >
                  <SPSelectField
                    title={'Activity'}
                    onChange={(value) => {
                      debouncedOnChangeFastFilter('activity', {
                        id: value?.id,
                      });
                    }}
                    schema={enumItems.activity}
                    defaultValue={undefined}
                    forcedValue={undefined}
                    disabled={false}
                    isMissing={false}
                    accordingToValue={undefined}
                  />
                </Box>
                <Box
                  sx={{
                    width: '200px',
                  }}
                >
                  <SPSelectField
                    title={'Service Provider'}
                    onChange={(value) => {
                      debouncedOnChangeFastFilter('service_provider', {
                        id: value?.id,
                      });
                    }}
                    schema={enumItems.serviceProvider}
                    defaultValue={undefined}
                    forcedValue={undefined}
                    disabled={false}
                    isMissing={false}
                    accordingToValue={undefined}
                  />
                </Box>
                <Box
                  sx={{
                    width: '200px',
                  }}
                >
                  <SPSelectUserField
                    title={'Booking Agent'}
                    onChange={(value) => {
                      debouncedOnChangeFastFilter('booking_agent', {
                        id: value?.id,
                      });
                    }}
                    schema={userByRole('100')}
                    defaultValue={undefined}
                    forcedValue={undefined}
                    disabled={false}
                    isMissing={false}
                    accordingToValue={undefined}
                  />
                </Box>
                <Box
                  sx={{
                    width: '200px',
                  }}
                >
                  <SPSelectField
                    title={'Status'}
                    onChange={(value) => {
                      debouncedOnChangeFastFilter(
                        'service_reservation_status',
                        {
                          id: value?.id,
                        }
                      );
                    }}
                    schema={statuses.serviceReservationStatus}
                    defaultValue={undefined}
                    forcedValue={undefined}
                    disabled={false}
                    isMissing={false}
                    accordingToValue={undefined}
                  />
                </Box>
                <Box
                  sx={{
                    width: '200px',
                  }}
                >
                  <SPSelectField
                    title={'Activity Category'}
                    onChange={(value) => {
                      debouncedOnChangeFastFilter('activity_category', {
                        id: value?.id,
                      });
                    }}
                    schema={enumItems.activityCategory}
                    defaultValue={undefined}
                    forcedValue={undefined}
                    disabled={false}
                    isMissing={false}
                    accordingToValue={undefined}
                  />
                </Box>
                <Box
                  sx={{
                    width: '200px',
                  }}
                >
                  <SPSelectField
                    title={'Activity Type'}
                    onChange={(value) => {
                      debouncedOnChangeFastFilter('activity_type', {
                        id: value?.id,
                      });
                    }}
                    schema={enumItems.activityType}
                    defaultValue={undefined}
                    forcedValue={undefined}
                    disabled={false}
                    isMissing={false}
                    accordingToValue={undefined}
                  />
                </Box>
              </Stack>
            )}
          </>
        )}
      </Stack>

      {addingEntity && (
        <></>
        /*<EntityDialog
          onClose={() => setAddingEntity(false)}
          schema={schema}
          onSubmit={onEntityAdded}
          properties={newEntityFixedValues}
          isOpen={addingEntity}
        />*/
      )}

      {open && (
        <Dialog
          onClose={() => setOpen(false)}
          open={open}
          title={'Get Me Home'}
        >
          <table
            ref={elementRef}
            style={{
              fontFamily: 'Arial, Helvetica, sans-serif',
              borderCollapse: 'collapse',
              margin: '0 auto',
              background: '#fff',
              width: '100%',
            }}
          >
            <tr>
              <th
                style={{
                  padding: '12px 8px',
                  textAlign: 'center',
                  border: '1px solid #ddd',
                }}
                colSpan={2}
              >
                Get Me Home
              </th>
            </tr>
            <tr>
              <td
                colSpan={2}
                style={{
                  textAlign: 'center',
                }}
              >
                SE Hungary
              </td>
            </tr>
            <tr>
              <td
                style={{
                  padding: '8px',
                  border: '1px solid #ddd',
                  textAlign: 'left',
                }}
              >
                Accommodation
              </td>
              <td
                style={{
                  padding: '8px',
                  border: '1px solid #ddd',
                  textAlign: 'left',
                }}
              >
                {open?.bookings && (
                  <>
                    {open.bookings.map((accomRes: any) => {
                      console.log(accomRes?.accommodation);
                      return accomRes?.accommodation?.name ? (
                        <p>{accomRes?.accommodation?.name}</p>
                      ) : (
                        <></>
                      );
                    })}
                  </>
                )}
              </td>
            </tr>
            <tr>
              <td
                style={{
                  padding: '8px',
                  border: '1px solid #ddd',
                  textAlign: 'left',
                }}
              >
                Address
              </td>
              <td
                style={{
                  padding: '8px',
                  border: '1px solid #ddd',
                  textAlign: 'left',
                }}
              >
                {open?.bookings && (
                  <>
                    {open.bookings.map((accomRes: any) => {
                      if (accomRes?.accommodation?.addresses) {
                        return (
                          <div key={accomRes.id}>
                            {accomRes.accommodation.addresses.map(
                              (addr: any, index: number) => {
                                let name = '';
                                if (addr?.name) {
                                  name = addr.name;
                                  if (addr?.address_line1) {
                                    name = `${name} (${addr.address_line1})`;
                                  }
                                } else {
                                  name = addr?.address_line1;
                                }

                                return <div key={index}>{name}</div>;
                              }
                            )}
                          </div>
                        );
                      }
                      return null;
                    })}
                  </>
                )}
              </td>
            </tr>
            <tr>
              <td
                style={{
                  padding: '8px',
                  border: '1px solid #ddd',
                  textAlign: 'left',
                }}
              >
                Taxi Plus
              </td>
              <td
                style={{
                  padding: '8px',
                  border: '1px solid #ddd',
                  textAlign: 'left',
                }}
              >
                +36 1 8 888 000
              </td>
            </tr>

            <tr>
              <td
                style={{
                  padding: '8px',
                  border: '1px solid #ddd',
                  textAlign: 'left',
                }}
              >
                Taxi 4
              </td>
              <td
                style={{
                  padding: '8px',
                  border: '1px solid #ddd',
                  textAlign: 'left',
                }}
              >
                +36 1 4 444 444
              </td>
            </tr>
            <tr>
              <td
                style={{
                  padding: '8px',
                  border: '1px solid #ddd',
                  textAlign: 'left',
                }}
              >
                Guide
              </td>
              <td
                style={{
                  padding: '8px',
                  border: '1px solid #ddd',
                  textAlign: 'left',
                }}
              >
                {open?.guides && (
                  <>
                    {open.guides.map((guide: any) => {
                      let name = '';
                      if (guide?.name) {
                        name = guide.name;
                        if (guide?.phone) {
                          name = `${name} (${guide.phone})`;
                        }
                      }

                      return <p>{name}</p>;
                    })}
                  </>
                )}
              </td>
            </tr>

            <tr>
              <td
                style={{
                  padding: '8px',
                  border: '1px solid #ddd',
                  textAlign: 'left',
                }}
              >
                Office
              </td>
              <td
                style={{
                  padding: '8px',
                  border: '1px solid #ddd',
                  textAlign: 'left',
                }}
              >
                +36 30 415 4116
              </td>
            </tr>
          </table>
          <Button
            variant={'contained'}
            onClick={() => {
              htmlToImageConvert();
            }}
          >
            Download Image
          </Button>
        </Dialog>
      )}

      {anchorEl?.open && (
        <Popover
          open={anchorEl.open}
          anchorEl={anchorEl.anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
        >
          <List
            component="nav"
            sx={{
              '& .MuiListItemIcon-root': {
                minWidth: '36px',
              },
            }}
            onClick={() => {}}
          >
            {/*   <ListItemButton
              onClick={(event) => {
                if (setCurrentAddNewRow) {
                  setCurrentAddNewRow({
                    id: 'new',
                    group: newEntityFixedValues?.group,
                  });
                  setAnchorEl({
                    anchorEl: null,
                    open: false,
                  });
                }
              }}
            >
              <ListItemIcon>
                <PlaylistAddRoundedIcon color={'primary'}/>
              </ListItemIcon>
              <ListItemText>Add New</ListItemText>
            </ListItemButton>*/}

            <ListItemButton
              onClick={(event) => {
                if (apiRef) {
                  apiRef.current.showFilterPanel();
                }
              }}
            >
              <ListItemIcon>
                <FilterAltRounded color={'primary'} />
              </ListItemIcon>
              <ListItemText>Filters</ListItemText>
            </ListItemButton>
            <ListItemButton
              onClick={(event) => {
                if (setPopupState) {
                  setPopupState(true);
                }
              }}
            >
              <ListItemIcon>
                <ViewWeekRounded color={'primary'} />
              </ListItemIcon>
              <ListItemText>Manage Columns</ListItemText>
            </ListItemButton>

            {schema?.showDeleted && (
              <>
                <ListItemButton
                  onClick={(event) => {
                    if (setShowDeleted) {
                      setShowDeleted(!showDeleted);
                    }
                  }}
                >
                  <ListItemIcon>
                    <DeleteSweepRounded color={'primary'} />
                  </ListItemIcon>
                  <ListItemText>
                    {' '}
                    {showDeleted ? 'Hide archive' : 'Show archive'}
                  </ListItemText>
                </ListItemButton>
              </>
            )}

            {schema?.name === 'Activity Reservation' && (
              <>
                <ListItemButton
                  onClick={() => {
                    if (setFilterOriginalAndFinalPrice) {
                      setFilterOriginalAndFinalPrice(
                        !filterOriginalAndFinalPrice
                      );
                    }
                  }}
                >
                  <ListItemIcon>
                    <DifferenceRounded color={'primary'} />
                  </ListItemIcon>
                  <ListItemText>
                    {' '}
                    {filterOriginalAndFinalPrice
                      ? 'Hide Different Prices'
                      : 'Show Different Prices'}
                  </ListItemText>
                </ListItemButton>

                <ListItemButton
                  onClick={() => {
                    if (handleDownloadMasterSettlementRiport) {
                      handleDownloadMasterSettlementRiport();
                    }
                  }}
                >
                  <ListItemIcon>
                    <DownloadRounded color={'primary'} />
                  </ListItemIcon>
                  <ListItemText> Settlement Report</ListItemText>
                </ListItemButton>
              </>
            )}

            {schema.name === 'Group' && selectedRowId && (
              <>
                <Divider />
                <GuideSchedule values={selectedRowId} listItem={true} />
                <ListItemButton
                  onClick={(event) => {
                    handleOpenGetMeHome();
                  }}
                >
                  <ListItemIcon>
                    <RemoveRedEyeRoundedIcon color={'primary'} />
                  </ListItemIcon>
                  <ListItemText>Get Me Home</ListItemText>
                </ListItemButton>
                {/*<PDFDownloadLink
                  document={<FeedBackForm />}
                  fileName="feedback.pdf"
                  className={'mr-[5px]'}
                >
                  <Button icon="document" text={`Feedback From`} />
                </PDFDownloadLink>*/}
              </>
            )}
            {fillOptions && (
              <>
                <Divider />
                <ListItemButton
                  onClick={(event) => {
                    fillOptionSend('size');
                  }}
                >
                  <ListItemIcon>
                    <RefreshRoundedIcon />
                  </ListItemIcon>
                  <ListItemText>Fill Size</ListItemText>
                </ListItemButton>
                <ListItemButton
                  onClick={(event) => {
                    fillOptionSend('guide');
                  }}
                >
                  <ListItemIcon>
                    <RefreshRoundedIcon />
                  </ListItemIcon>
                  <ListItemText>Fill Group Guides</ListItemText>
                </ListItemButton>
                <ListItemButton
                  onClick={(event) => {
                    fillOptionSend('time');
                  }}
                >
                  <ListItemIcon>
                    <AccessTimeIcon />
                  </ListItemIcon>
                  <ListItemText>Fill Times</ListItemText>
                </ListItemButton>

                <Divider />
                <ListItemButton
                  onClick={(event) => {
                    fillOptionSend('plus');
                  }}
                >
                  <ListItemIcon>
                    <AddRoundedIcon />
                  </ListItemIcon>
                  <ListItemText>Add 1 Person For All Activities</ListItemText>
                </ListItemButton>
                <ListItemButton
                  onClick={(event) => {
                    fillOptionSend('minus');
                  }}
                >
                  <ListItemIcon>
                    <RemoveRoundedIcon />
                  </ListItemIcon>
                  <ListItemText>
                    Deduct 1 Person For All Activities
                  </ListItemText>
                </ListItemButton>
              </>
            )}
            {showCSVImport && (
              <>
                <Divider />
                <ListItemButton onClick={(event) => {}}>
                  <ListItemIcon>
                    <CloudUploadRounded />
                  </ListItemIcon>
                  <ListItemText>
                    <CSVReader schema={schema} onSubmit={onEntityAdded} />
                  </ListItemText>
                </ListItemButton>
                <ListItemButton onClick={(event) => {}}>
                  <ListItemIcon>
                    <CloudDownloadRoundedIcon />
                  </ListItemIcon>
                  <ListItemText>
                    <CsvDownloader
                      filename={`${schema.pluralName
                        .toLowerCase()
                        .replace(' ', '-')}`}
                      datas={[processedColumns]}
                      text="Download csv template"
                      style={{
                        color: '#58647d',
                      }}
                      className={'mr-[5px]'}
                    />
                  </ListItemText>
                </ListItemButton>
              </>
            )}
            {/* {data && (
              <>
                <Divider/>
                <ListItem>
                  <CsvDownloader
                    filename={`${schema.pluralName
                      .toLowerCase()
                      .replace(' ', '-')}-database`}
                    datas={data}
                    text="Export in Excel"
                    style={{
                      color: '#1c2127',
                      background: '#f6f7f9',
                      borderRadius: '6px',
                      padding: '5px 10px',
                      minHeight: '30px',
                      minWidth: '30px',
                    }}
                  />
                </ListItem>
              </>
            )}*/}

            {schema.name === 'Group' && (
              <>
                <Divider />
                <ListItemButton
                  onClick={(event) => {
                    refreshStatusHandleClick();
                  }}
                >
                  <ListItemIcon>
                    <RotateRightRounded color={'primary'} />
                  </ListItemIcon>
                  <ListItemText>Refresh Statuses (A/B/S)</ListItemText>
                </ListItemButton>
              </>
            )}

            <Divider />
            <ListItemButton
              onClick={() => {
                if (exportToXLSX) {
                  exportToXLSX();
                }
              }}
            >
              <ListItemIcon>
                <SaveAltRounded color={'primary'} />
              </ListItemIcon>
              <ListItemText>Export</ListItemText>
            </ListItemButton>
          </List>
        </Popover>
      )}

      {showSendNotification && (
        <ServiceReservationModificationDialog
          type={'all'}
          values={checkedRows}
          onClose={() => {
            setShowSendNotification(false);
          }}
        />
      )}

      {openFilterModal && (
        <Dialog
          open={openFilterModal}
          onClose={() => setOpenFilterModal(false)}
          fullWidth
        >
          <DialogTitle>Filter Options</DialogTitle>
          <DialogContent>
            <Stack direction="column" alignItems={'center'} gap={1}>
              <Autocomplete
                fullWidth
                PopperComponent={LargePopper}
                id="main-menu-sales-partner-filter"
                onOpen={() => fetchSalesPartnerOptions()}
                options={salesPartnerOptions}
                value={spOption}
                getOptionLabel={(option: any) => option?.name}
                getOptionKey={(option: any) => option?.id}
                size={'small'}
                renderInput={(params) => (
                  <TextField {...params} label="Sales Partner" size={'small'} />
                )}
                isOptionEqualToValue={(option, value) => {
                  return option.id === value.id;
                }}
                onChange={(event, newValue) => {
                  handleItemSelect(newValue, 'sp');
                }}
              />

              <Autocomplete
                fullWidth
                PopperComponent={LargePopper}
                id="main-menu-booking-agent-filter"
                onOpen={() => fetchBookingAgentOptions()}
                options={options}
                value={viewAgentOption}
                getOptionLabel={(option: any) => option?.name}
                getOptionKey={(option: any) => option?.id}
                size={'small'}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Booking Manager"
                    size={'small'}
                  />
                )}
                isOptionEqualToValue={(option, value) => {
                  return option.id === value.id;
                }}
                onChange={(event, newValue) => {
                  handleItemSelect(newValue, 'ba');
                }}
              />

              <Autocomplete
                fullWidth
                id="main-menu-guide-filter"
                PopperComponent={LargePopper}
                onOpen={() => fetchGuideOptions()}
                options={guideOptions}
                value={guideOption}
                getOptionLabel={(option: any) => option?.name}
                getOptionKey={(option: any) => option?.id}
                size={'small'}
                renderInput={(params) => (
                  <TextField {...params} label="Guide" size={'small'} />
                )}
                isOptionEqualToValue={(option, value) => {
                  return option.id === value.id;
                }}
                onChange={(event, newValue) => {
                  handleItemSelect(newValue, 'g');
                }}
              />
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenFilterModal(false)}>Close</Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};
